/* Moteur configurateur lit à eau v2 — chargé quand custom.config contient la clé "v2".
   PDF-exact (base auditée akva-tarif) : 3 systèmes (uno / dual / kombi), stabilisation PAR CÔTÉ en
   deux-matelas (prix = colonne de la moyenne (A+B)/2, même famille imposée), tête de lit (remise −308
   sur les Select via jeu de variantes dédié), échange de socle (deltas), dimensions sur mesure guidées,
   déductions par code promo (Shopify interdit les lignes négatives), Boxkit, Vega, Lyra (2 tables).
   Rail d'étapes 01→08 repliables + barre de prix sticky. Zéro emoji — SVG uniquement. */
(function () {
  'use strict';

  /* ── helpers ── */
  /* PERF-07, 23/09/2026 — UN FORMATEUR CONSTRUIT UNE FOIS, ET SES RESULTATS GARDES.

     `toLocaleString` reconstruit un `Intl.NumberFormat` a chaque appel. Ici ce n'est PAS
     le gros poste, et il faut le dire : le profileur V8 rangeait 210 ms sous `euro`, mais
     le comptage d'appels (sonde du 23/09) en trouve **26 par chargement**. Vingt-six
     appels ne font pas 210 ms : ce que le profileur attribuait a `euro`, c'est
     l'initialisation d'ICU que le PREMIER formatage declenche, et qu'aucune memoisation
     ne supprime. Le gain reel ici est donc modeste, et non mesurable separement.

     ⚠ La ou il est net, c'est dans le pilote : 156 appels par chargement, donc 156
       constructions de formateur, ramenees a une seule.

     Sortie inchangee, et verifiee : 5 536 comparaisons valeur par valeur entre l'ancienne
     ecriture et celle-ci (ronds, tranches du tarif, negatifs, non-entiers, purge du cache,
     cles heritees) — zero ecart. `toLocaleString` n'est que du sucre par-dessus
     `Intl.NumberFormat` : memes options, meme texte.

     ⚠ Le dictionnaire est `Object.create(null)` : avec un objet ordinaire, `_M0['constructor']`
       rendrait une fonction au lieu de `undefined`, et le cache servirait n'importe quoi. */
  var _NF0 = null, _M0 = Object.create(null), _M0n = 0;
  function _fr0(n) {
    var v = _M0[n];
    if (v !== undefined) return v;          /* deja vu : le meme montant revient sans arret */
    if (_NF0 === null) {
      _NF0 = (window.Intl && Intl.NumberFormat)
        ? new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 }) : false;
    }
    v = _NF0 ? _NF0.format(n) : n.toLocaleString('fr-FR', { maximumFractionDigits: 0 });
    /* plafond : un cache sans borne dans une page qui vit longtemps est une fuite
       silencieuse. Un configurateur n'expose qu'une centaine de montants ; au-dela
       on repart a zero plutot que de grossir. */
    if (_M0n > 400) { _M0 = Object.create(null); _M0n = 0; }
    _M0[n] = v; _M0n++;
    return v;
  }
  function euro(c) { return _fr0(c / 100) + ' €'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var SVG_CHECK = '<svg viewBox="0 0 16 16" width="11" height="11" aria-hidden="true"><path d="M2.5 8.5l3.5 3.5 7-8" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_LOCK = '<svg viewBox="0 0 16 16" width="10" height="10" aria-hidden="true"><rect x="3" y="7" width="10" height="7" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M5 7V5a3 3 0 0 1 6 0v2" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
  /* coupes de matelas (diagrammes système) — trait crème, eau laiton */
  function svgSys(kind) {
    var w = 64, h = 30, o = '<svg viewBox="0 0 64 30" width="64" height="30" aria-hidden="true" fill="none">';
    var base = '<rect x="2" y="6" width="60" height="18" rx="4" stroke="rgba(242,236,225,.55)" stroke-width="1.4"/>';
    if (kind === 'uno') o += base + '<path d="M6 15c6-4 12 4 18 0s12 4 18 0 12 4 16 0" stroke="#CDA76A" stroke-width="1.6" stroke-linecap="round"/>';
    if (kind === 'dual') o += base + '<line x1="32" y1="6" x2="32" y2="24" stroke="rgba(242,236,225,.55)" stroke-width="1.4"/>' +
      '<path d="M6 15c4-3 8 3 12 0s8 3 11 0" stroke="#CDA76A" stroke-width="1.6" stroke-linecap="round"/>' +
      '<path d="M35 15c4-3 8 3 12 0s8 3 11 0" stroke="#CDA76A" stroke-width="1.6" stroke-linecap="round"/>';
    if (kind === 'kombi') o += base + '<line x1="32" y1="9" x2="32" y2="21" stroke="rgba(242,236,225,.45)" stroke-width="1.2" stroke-dasharray="2.5 2.5"/>' +
      '<path d="M6 15c5-3 10 3 15 0s8 3 9 0c1 3 4-3 9 0s10 3 19 0" stroke="#CDA76A" stroke-width="1.6" stroke-linecap="round"/>' +
      '<path d="M4 4h56" stroke="rgba(242,236,225,.55)" stroke-width="1.4" stroke-linecap="round"/>';
    return o + '</svg>';
  }

  /* options des têtes : compatibilités structurelles (données de prix = produits d'appoint) */
  var TETE_OPTS = {
    'tete-k2': { surpiqures: 1, hauteur: 1, boutons: ['Boutons ×6 (90-120)', 'Boutons ×8 (140-160)', 'Boutons ×12 (180-200)'] },
    'tete-mt-thomas': { surpiqures: 1, hauteur: 1, boutons: ['Boutons ×9 (90-120)', 'Boutons ×15 (140-160)', 'Boutons ×21 (180-200)'] },
    'tete-plateau': { surpiqures: 1, hauteur: 1 },
    'tete-olympus': { surpiqures: 1, hauteur: 1, etendue: 1, reduite: 1 },
    'tete-anton': {}, 'tete-oskar': {},
    'tete-hugo': { hauteur: 1, coussins: 1 },
    'tete-mt-ventoux': { coussins: 1 }, 'tete-mt-ventoux-comfort': {}
  };
  /* 🛑 LA LARGEUR REELLE DE CHAQUE TETE — lue dans la BOUTIQUE, pas deduite.
     Signalement du 20/09 : « certaine depasse du lit au centimetre pres ou
     d'autre a largeur du lit cm pres ». Une tete Hugo sur un lit de 140 fait
     188 cm ; le client ne l'apprenait nulle part.
     Source : champ « Largeur » de `custom.specs`, relu le 20/09/2026 sur les
     NEUF fiches — « largeur du lit + 48 cm (24 cm de debord de chaque cote) »
     pour Hugo, « exactement celle du lit, aucun debord » pour K2. Recoupe avec
     `largeur_ajoutee_cm` du tableau Akva (pp. 23-30) : neuf accords sur neuf.
     ⚠️ Elle vit ICI et pas dans `custom.config` parce qu'un metachamp est une
        donnee de boutique, qui ne se modifie pas sans l'avoir propose. Le jour
        ou elle y entre, cette table se SUPPRIME — elle ne se duplique pas. */
  var TETE_DEBORD = {
    'tete-k2': 0, 'tete-mt-thomas': 44, 'tete-plateau': 20, 'tete-olympus': 24,
    'tete-anton': 0, 'tete-oskar': 0, 'tete-hugo': 48,
    'tete-mt-ventoux': 0, 'tete-mt-ventoux-comfort': 0
  };

  function init(root) {
    var cfgEl = root.querySelector('[data-cf-config]'), varEl = root.querySelector('[data-cf-variants]');
    if (!cfgEl || !varEl) return;
    var cfg, variants;
    try { cfg = JSON.parse(cfgEl.textContent); variants = JSON.parse(varEl.textContent); } catch (e) { return; }
    var V = cfg && cfg.v2; if (!V) return;
    if (V.cadre) return initCadre(root, cfg, variants, V);
    var mount = root.querySelector('[data-cf-mount]');
    var priceEl = root.querySelector('[data-cf-price]');
    var bar = root.querySelector('[data-cf-bar]');
    var errEl = root.querySelector('[data-cf-err]');
    var bigsw = root.querySelector('[data-cf-bigsw]');
    var finN = root.querySelector('[data-cf-finn]'), finK = root.querySelector('[data-cf-fk]');
    if (!mount) return;

    /* index variantes : option1 -> col -> {id, cents} */
    var VMAP = {};
    variants.forEach(function (v) {
      (VMAP[v.formule] = VMAP[v.formule] || {})[v.stab] = { id: v.id, cents: v.cents };
    });

    /* 🛑 UN PRIX, TOUJOURS. Le bandeau affichait « — » tant qu'aucune variante
       n'etait resolue — c'est-a-dire pendant tout le debut du parcours, celui ou
       l'on hesite. Signalement du 07/09 : « y'a aucun prix nulle part ». Le
       plancher, lui, est connu des le chargement : c'est la variante la moins
       chere du modele. On l'affiche en attendant le prix exact. */
    var PLANCHER = (function () {
      /* 🛑 LE BOXKIT N'EST PAS UN LIT. Sur le Boxbed, la variante la moins chere
         est le « Boxkit » a 908 € : un cadre, un socle et des plaques, SANS
         matelas. L'annoncer comme prix de depart du lit, c'est promettre a
         908 € un couchage qui en vaut 2 815 — l'erreur exacte que le journal a
         deja payee sur ce produit. On ecarte donc les formules Boxkit du
         plancher ; elles restent achetables, elles ne servent juste pas de
         vitrine. */
      var m = null;
      variants.forEach(function (v) {
        if (/^Boxkit/i.test(String(v.formule || ''))) return;
        if (m === null || v.cents < m) m = v.cents;
      });
      if (m === null) variants.forEach(function (v) { if (m === null || v.cents < m) m = v.cents; });
      return m;
    })();

    var isLyra = !!V.lyraRows, isBoxkitable = !!V.boxkit;
    var stabByKey = {}; V.stabs.forEach(function (s) { stabByKey[s.key] = s; });

    /* ── état ── */
    var S = {
      line: (V.lines[0] || {}).key, system: null, width: null, length: null,
      dimspec: null,               /* {w,l,tier} */
      stabL: null, stabR: null, sameStab: true, lsL: false, lsR: false,
      cadre: null, cadreUrl: null, socleCol: null, socleColUrl: null,
      mousse: null, revetement: null, matType: 'Standard',
      socleH: '25/30 cm', socleCm: null, socleType: null, facades: false, socleSurMesure: false,
      /* 🛑 la hauteur demandee, en cm. `socleSurMesure` etait le seul
         temoin, et il ne disait PAS laquelle : facturer 75 € sans
         savoir quelle hauteur fabriquer n'est pas une commande. */
      socleSmCm: null, _socleSmOpen: false,
      /* Tarif p.34 : sur les box STANDARD, « choisir entre glissieres ou
         roulettes ». Sur les Big Box (p.35) c'est roulettes d'office, sans
         choix. Aucun supplement des deux cotes : c'est une propriete, pas
         un prix. `null` tant que le client n'a rien dit. */
      coulissement: null,
      tete: null, teteTier: null, teteOpt: {}, teteInc: null, teteCol: null, teteColUrl: null,
      pieds: false, surpiq: false, ded: { liner: false, dessus: false },
      vega: { tete: null, cadre: null, lampes: false, pouf: null },
      boxkit: false, open: 0
    };

    /* couleurs recommandees du modele : le lit s'affiche « habille » des l'ouverture.
       cadreSource='socle' quand le cadre est en BOIS (Nordic/Modulex) : les placages ne sont pas
       dans les couleurs de cadre du site mais dans celles de socle. */
    /* 🛑 LA TETE ATTITREE EST INCLUSE DES LE DEPART. Demande du 07/09 : « dès le
       départ dans le configurateur on commence avec la tête de lit incluse dans
       le prix total, et une fois sur la section 06 il a possibilité de ne pas la
       mettre et il récupère X ». Le total s'ouvre donc sur le lit HABILLE, et
       retirer la tete devient une economie visible plutot qu'un supplement cache.
       ⚠️ Ce n'est PAS le pre-cochage qu'on a corrige ce matin : la, une pastille
       « Sans tête » s'allumait alors que RIEN n'etait choisi. Ici un vrai choix,
       chiffre, est en place — et `_teteTouched` le dit honnetement.
       ⚠️ Ne concerne que les modeles ou la tete est un SUPPLEMENT (optional,
       select). Sur Carla et Lyra elle est INCLUSE au tarif a 0 €, et sur le Vega
       elle fait partie du systeme : il n'y a rien a inclure ni a economiser. */
    /* 🛑 LE SOCLE LIVRE D'OFFICE SE POSE COMME UN DEFAUT, PAS COMME UNE REMISE.
       Le Nordic part en placage chene huile : son prix doit s'ouvrir a
       2 970 + 243 = 3 213 EUR (90/100/120). La tentation etait de monter le prix
       des variantes du LIT puis de soustraire le placage de l'echange — mais un
       appoint porte l'ID d'une variante, et c'est le prix de CETTE variante que
       le panier facture. Le client aurait lu « + 300 € » et paye 543.
       On selectionne donc le socle inclus comme n'importe quel choix : le total
       s'ouvre avec lui, le panier recoit sa vraie variante, et l'ecart d'un
       tiroir se calcule tout seul contre lui (728 − 428 = 300).
       Meme mecanique que la tete attitree, posee le 07/09 juste au-dessus. */
    /* 🛑 ON POSE LA VALEUR, ON NE TEMOIGNE PLUS DU CHOIX.
       Ces branches posaient `S._socleVu = true` des l'initialisation : le socle
       etait donc declare « fait » avant le premier clic. Mesure du 20/09 sur le
       Soft, sans aucune action : `socleVu=true`, `etapes.socle="fait"`, « 1 / 7 »
       et 14 % de jauge — alors que ni la hauteur ni la couleur n'avaient ete
       choisies. Le signalement etait exact, mot pour mot.
       La valeur par defaut RESTE (le lit doit s'ouvrir habille pour que le total
       soit le vrai prix — demande du 07/09, expliquee juste au-dessus) ; c'est le
       TEMOIN qui part. Poser un defaut et constater une decision sont deux
       gestes differents, et un seul des deux appartient au client.
       La seconde branche ne faisait QUE poser ce temoin : elle disparait. */
    if (V.socle && V.socle.inclus && !S.socleType) {
      S.socleType = V.socle.inclus;
    }
    /* ⚠️ POUR MEMOIRE — une branche a vecu ici. Sur le Nordic Select, le socle
       compris est le box en Decor : il ne s'echange contre rien, donc `inclus`
       est vide et `socleType` reste null. On en profitait pour declarer le socle
       « vu ». C'etait le raccourci qui faisait cocher l'etape 04 sans que
       personne n'ait rien choisi. Le vrai manque etait ailleurs : le TYPE de
       socle n'avait pas d'etape a lui. Il en a une maintenant. */

    if (V.tete && (V.tete.mode === 'optional' || V.tete.mode === 'select')
        && V.tete.defaultHandle && !S.tete) {
      S.tete = V.tete.defaultHandle;
      /* ⚠️ `S._teteTouched` ne se pose plus ici — meme raison que pour le socle.
         La tete attitree reste incluse des le depart et le total s'ouvre habille ;
         mais l'etape « La tete de lit » attend toujours un vrai choix. Mesure du
         20/09 : elle sortait « fait » sur nordic, nordic-select, boxbed, carla et
         vega, et portait le compteur du Nordic a 2/7 sans un seul clic. */
    }
    /* Le Vega a sa propre gamme de tetes — et elles sont PAYANTES : le tarif
       lui donne trois lignes (900 € Athina/Luke/Hot Madison, 1 845 € Re-wool,
       2 290 € cuir, lits_options.csv l.103-105). Il n'est donc pas un modele
       « tete incluse » : il suit la meme regle que les autres, la moins chere
       de sa gamme comprise d'office. */
    if (V.tete && V.tete.mode === 'vega' && V.tete.vega && V.tete.vega.tete && !S.vega.tete) {
      var moins = null, pxm = null;
      Object.keys(V.tete.vega.tete).forEach(function (k) {
        var px = (V.tete.vega.tete[k] || {}).price;
        if (typeof px === 'number' && (pxm === null || px < pxm)) { pxm = px; moins = k; }
      });
      /* la moins chere de la gamme est comprise d'office ; ce n'est pas un choix du client */
      if (moins) { S.vega.tete = moins; }
    }
    /* Carla : ses deux tetes sont INCLUSES a 0 € (lits_options.csv l.101). Il n'y
       a donc rien a economiser, mais il y a un choix de forme a faire — on en
       pose une pour que le lit s'ouvre habille, et elle se change librement. */
    if (V.tete && V.tete.mode === 'included' && (V.tete.included || []).length > 0
        && !S.teteInc) {
      S.teteInc = V.tete.included[0];
      /* ⚠️ Carla : une forme est posee pour que le lit s'ouvre habille, elle se
         change librement — mais personne n'a encore tranche. */
    }

    var DEF = V.defaults || {};
    var CADRE_GRP = (V.cadreSource === 'socle' ? cfg.socle : cfg.cadre) || {};
    if (DEF.cadre) { S.cadre = DEF.cadre.name; S.cadreUrl = DEF.cadre.url; }
    if (DEF.socle) { S.socleCol = DEF.socle.name; S.socleColUrl = DEF.socle.url; }
    /* hauteurs de socle REELLES (fiches akva.com) : une seule valeur = hauteur fixe du modele.
       Les libelles « 25/30 » et « 34/37,5 » du tarif ne sont que des TRANCHES DE PRIX. */
    var HEIGHTS = (V.socle && V.socle.heights) || null;
    var LAYING = (V.socle && V.socle.layingPlus) || 24;
    function hLabel(h) { return String(h).replace('.', ',') + ' cm'; }
    function bracketOf(h) { return h <= 30 ? '25/30 cm' : '34/37,5 cm'; }
    if (HEIGHTS && HEIGHTS.length) { S.socleCm = HEIGHTS[0]; S.socleH = bracketOf(S.socleCm); }
    function heightPills(sel) {
      return pills(HEIGHTS.map(function (h) {
        return { v: String(h), label: hLabel(h), tip: 'socleh:' + h };
      }), 'socleh', String(sel));
    }
    function heightBlock() {
      if (!HEIGHTS) return '<div class="cf2__subk">Hauteur</div>' + pills([{ v: '25', label: '25 / 30 cm', tip: 'socleh:25' }, { v: '34', label: '34 / 37,5 cm', tip: 'socleh:34' }], 'socleh', String(S.socleCm || 25));
      if (HEIGHTS.length === 1) {
        return '<div class="cf2__fixed" data-tip="socleh:' + HEIGHTS[0] + '"><span>Hauteur de ce mod\u00e8le</span>' +
          '<b>Socle ' + hLabel(HEIGHTS[0]) + '</b><i>couchage \u00e0 ~' + hLabel(HEIGHTS[0] + LAYING) + '</i></div>';
      }
      return '<div class="cf2__subk">Hauteur de socle</div>' + heightPills(S.socleCm);
    }
    function line() { var out = null; V.lines.forEach(function (l) { if (l.key === S.line) out = l; }); return out || V.lines[0]; }
    function sysAllowed(k) {
      var l = line();
      if (l.systems.indexOf(k) < 0) return { ok: false, why: l.label + ' existe en ' + l.systems.map(function (s) { return sysDef(s).label.toLowerCase(); }).join(' ou ') };
      return { ok: true };
    }
    function sysDef(k) { var out = null; V.systems.forEach(function (s) { if (s.key === k) out = s; }); return out; }
    function twoSides() { return S.system === 'dual' || S.system === 'kombi'; }

    /* ── dimensions ── */
    function bandsList() { return V.bands || []; }
    function widthsAll() {
      if (isLyra) {
        var seen = {}, out = [];
        V.lyraRows.forEach(function (r) { if (rowHeightOK(r)) r.widths.forEach(function (w) { if (!seen[w]) { seen[w] = 1; out.push(w); } }); });
        return out.sort(function (a, b) { return (+a) - (+b); });
      }
      var out2 = [];
      bandsList().forEach(function (b) { b.widths.forEach(function (w) { out2.push(w); }); });
      return out2;
    }
    function rowHeightOK(r) { return r.o1.indexOf(S.socleH.indexOf('34') >= 0 ? '34/37,5' : '25/30') >= 0; }
    function widthInfo(w) {
      /* renvoie {ok, why} pour la largeur au regard du système + ligne choisis */
      var l = line(), sys = S.system;
      if (!sys) return { ok: false, why: 'Choisissez d’abord votre couchage' };
      if (isLyra) {
        var rows = V.lyraRows.filter(function (r) { return rowHeightOK(r) && r.system === sys && r.widths.indexOf(w) >= 0; });
        return rows.length ? { ok: true } : { ok: false, why: sys === 'dual' ? 'En deux matelas, le Lyra démarre à 160 cm' : 'Indisponible dans cette configuration' };
      }
      var min = sys === 'uno' ? 90 : sys === 'dual' ? (l.dualMin || 140) : 150;
      if (parseInt(w, 10) < min) {
        var why = sys === 'kombi' ? 'Les matelas combinés démarrent à 150 cm' :
          (l.dualMin === 150 ? l.label + ' : deux matelas à partir de 150 cm' : 'Deux matelas à partir de 140 cm');
        return { ok: false, why: why };
      }
      return { ok: true };
    }
    function lengthsFor(w) {
      if (isLyra) {
        var out = [];
        V.lyraRows.forEach(function (r) {
          if (rowHeightOK(r) && r.system === S.system && r.widths.indexOf(w) >= 0) r.lengths.forEach(function (x) { if (out.indexOf(x) < 0) out.push(x); });
        });
        return out;
      }
      var b = bandFor(w); return b ? b.lengths : [];
    }
    function bandFor(w) {
      var out = null; bandsList().forEach(function (b) { if (b.widths.indexOf(String(w)) >= 0) out = b; });
      return out;
    }
    function bandKeyForLS() {
      if (isLyra) return (S.system === 'uno' && parseInt(S.width, 10) <= 100) ? 'b1' : 'b2';
      var b = bandFor(S.width); return b ? b.key : null;
    }

    /* Le support lombaire est-il possible AVEC CE QUI EST CHOISI, et a quel prix ?
       Repond aux deux questions que la page pose sans savoir y repondre.
       ⚠️ Tout est garde : un lit sans `V.ls` (aucun support au tarif) doit rendre
       `false` et `0`, pas lever une erreur qui tuerait tout l'evenement. */
    function lsDispoNow() {
      if (!V.ls) return false;
      var ks = twoSides() ? [S.stabL, S.sameStab ? S.stabL : S.stabR] : [S.stabL];
      return ks.some(function (k) { return k && stabByKey[k] && stabByKey[k].ls; });
    }
    function lsPrixNow() {
      if (!V.ls || !lsDispoNow()) return 0;
      var d = twoSides() ? V.ls.dual : (V.ls[bandKeyForLS()] || V.ls.b2);
      return d ? d.price : 0;
    }

    /* ── stabilisation / prix ── */
    function stabsFor() { return V.stabs; }
    function colOf(k) { return (stabByKey[k] || {}).col; }
    function famOf(k) { return (stabByKey[k] || {}).fam; }
    function resolvedStab() {
      /* renvoie {col, resKey, mixed} ou null */
      if (S.boxkit) return { col: 'Boxkit (sans matelas)', resKey: null, mixed: false };
      if (!S.stabL) return null;
      if (!twoSides() || S.sameStab || !S.stabR || S.stabR === S.stabL)
        return { col: colOf(S.stabL), resKey: S.stabL, mixed: false };
      if (famOf(S.stabL) !== famOf(S.stabR)) return { err: 'Choisissez la même famille des deux côtés (fibres avec fibres, Ergo avec Ergo).' };
      if (famOf(S.stabL) === 'ergo') {
        if (colOf(S.stabL) !== colOf(S.stabR)) return { err: 'Ergo et F-Ergo ne se combinent pas entre eux.' };
        return { col: colOf(S.stabL), resKey: S.stabL, mixed: true };
      }
      var a = stabByKey[S.stabL].num, b = stabByKey[S.stabR].num;
      var avg = Math.round((a + b) / 2 + 0.0001); /* .5 arrondi au supérieur */
      var res = avg <= 2 ? (avg <= 0 ? 'F0' : 'F2') : 'F' + Math.min(avg, 8);
      return { col: colOf(res), resKey: res, mixed: true, avg: avg };
    }
    function rowO1() {
      if (isLyra) {
        var out = null;
        V.lyraRows.forEach(function (r) {
          if (rowHeightOK(r) && r.system === S.system && r.widths.indexOf(String(S.width)) >= 0) out = r.o1;
        });
        return out;
      }
      var b = bandFor(S.dimspec ? S.dimspec.baseW : S.width);
      if (!b) return null;
      if (S.boxkit) return 'Boxkit · ' + (b.widths[0] === '90' ? '90/100/120' : b.widths[0] === '140' ? '140/150/160' : '180/200');
      return S.system === 'uno' ? b.uno : b.dk;
    }
    function currentVariant() {
      var o1 = rowO1(), rs = resolvedStab();
      if (!o1 || !rs || rs.err) return null;
      return (VMAP[o1] || {})[rs.col] || null;
    }

    /* ── appoints ── */
    function apId(handle, key) { var m = (V.tete && V.tete.catalog ? null : null); return null; }
    /* 🛑 UN SOCLE QUI N'EXISTE PAS N'A PAS DE PRIX — il n'est pas GRATUIT.
       `appoints()` n'ajoute une ligne de socle que si `pickVar` trouve la
       combinaison. Quand elle manque — « 4 box » en 90/100/120, que le tarif
       n'imprime nulle part — la ligne disparaissait simplement, et le total
       retombait a celui d'un lit SANS socle. Sur le Nordic, dont le placage
       vaut 243 EUR, la vignette « Quatre tiroirs » annoncait donc 3 648 EUR
       contre 3 891 : moins cher que le socle inclus, pour quatre tiroirs en
       plus. Une configuration impossible doit rendre null, pas un prix. */
    function socleResoluble() {
      if (!S.socleType) return true;
      var bl = bandLabel();
      if (!bl) return true;
      return !!socleSwap(S.socleType);
    }

    function tryNet(mut) {
      /* prix total si on appliquait ce choix : mutation temporaire de S, puis restauration */
      var keys = Object.keys(mut), old = {};
      keys.forEach(function (k) {
        old[k] = S[k];
        /* 🛑 UNE MUTATION IMBRIQUEE DOIT FUSIONNER, PAS REMPLACER. `S.vega` porte
           quatre choix (tete, cadre, lampes, pouf) ; une mutation `{vega:{tete:x}}`
           ecrasait les trois autres, et le prix hypothetique perdait les lampes a
           1 323 € au passage — l'economie annoncee aurait ete fausse pour qui les
           a prises. On ne remplace que la cle citee. */
        if (k === 'vega' && S[k] && typeof S[k] === 'object'
            && mut[k] && typeof mut[k] === 'object') {
          var fusion = {};
          Object.keys(S[k]).forEach(function (x) { fusion[x] = S[k][x]; });
          Object.keys(mut[k]).forEach(function (x) { fusion[x] = mut[k][x]; });
          S[k] = fusion;
        } else {
          S[k] = mut[k];
        }
      });
      /* 🛑 UNE HAUTEUR HYPOTHETIQUE DOIT CHANGER DE TRANCHE.
         `socleCm` est la hauteur (25/30/34/37.5), `socleH` la TRANCHE DE PRIX
         ('25/30 cm' ou '34/37,5 cm'), et c'est la tranche que lisent
         `rowHeightOK` et la recherche d'echange de socle. Les deux sont poses
         ensemble au demarrage, mais une mutation ne portait que `socleCm` :
         le prix hypothetique restait dans la tranche courante. Sur le Lyra,
         dont le tarif p.18 a DEUX blocs, les quatre hauteurs annoncaient donc
         « meme prix » alors que 34/37,5 coute 340 EUR de plus — et le total,
         lui, changeait bien au clic. socleH derivee ici, une seule fois. */
      var _hAvant = S.socleH, _hMute = false;
      if (Object.prototype.hasOwnProperty.call(mut, 'socleCm')
          && !Object.prototype.hasOwnProperty.call(mut, 'socleH')
          && mut.socleCm != null) {
        S.socleH = bracketOf(parseFloat(mut.socleCm)); _hMute = true;
      }
      /* hypothese : sans l'installation, sinon le plancher la contiendrait */
      var out = (currentVariant() && socleResoluble()) ? totals(true).net : null;
      if (_hMute) { S.socleH = _hAvant; }
      keys.forEach(function (k) { S[k] = old[k]; });
      return out;
    }
    function deltaTxt(mut) {
      if (!currentVariant()) return '';
      /* les deux cotes de l'ecart doivent exclure l'installation : `tryNet`
         l'exclut deja, un `cur` qui l'inclurait rendrait tout ecart faux */
      var cur = totals(true).net, cand = tryNet(mut);
      if (cand == null) return '';
      var d = cand - cur;
      if (!d) return '';
      return (d > 0 ? '+ ' : '\u2212 ') + euro(Math.abs(d));
    }
    function pickVar(map, needle) {
      /* map: {"opt1 · opt2 · opt3": {id, price}} — retourne 1re entrée contenant tous les fragments */
      var frags = Array.isArray(needle) ? needle : [needle];
      var out = null;
      Object.keys(map || {}).forEach(function (k) {
        if (out) return;
        var ok = frags.every(function (f) { return k.indexOf(f) >= 0; });
        if (ok) out = { key: k, id: map[k].id, cents: Math.round(map[k].price * 100) };
      });
      return out;
    }
    /* 26/10 : le supplément de socle est un article PAR largeur et PAR hauteur (« c'est soit 25 soit 30, ce n'est pas
       les 2 en même temps », consigne de la propriétaire). La carte `v2.socle.swapExact` porte la clé
       « type|largeur|hauteur » ; on la lit par ÉGALITÉ STRICTE, jamais par fragments : « 25 » est contenu dans
       « 25 cm (Benti uniquement) », « 2 box » dans « 2-big box ». `socleCm` est toujours une hauteur standard (la
       hauteur sur mesure vit dans `socleSmCm`), donc la clé existe. Sans carte exacte, on retombe sur les tranches. */
    function socleSwap(t) {
      if (!t) return null;
      var X = V.socle && V.socle.swapExact;
      if (X) {
        var w = parseInt(S.dimspec ? S.dimspec.baseW : S.width, 10);
        var hh = t.indexOf('Benti') >= 0 ? '25 cm' : (S.socleCm != null ? hLabel(S.socleCm) : null);
        var k = w && hh ? t + '|' + w + '|' + hh : null, e = k ? X[k] : null;
        return e ? { key: k, id: e.id, cents: Math.round(e.price * 100) } : null;
      }
      var bl = bandLabel();
      if (!bl) return null;
      return pickVar(V.socle.swap, [t, bl, t.indexOf('Benti') >= 0 ? '25' : S.socleH])
        || (t.indexOf('Benti') >= 0 ? pickVar(V.socle.swap, [t, bl]) : null);
    }
    function facadesVar() {
      var X = V.socle && V.socle.optionsExact;
      if (X && S.socleCm != null) {
        var k = 'Façades rembourrées|' + hLabel(S.socleCm), e = X[k];
        if (e) return { key: k, id: e.id, cents: Math.round(e.price * 100) };
      }
      return pickVar(V.socle.options, S.socleH.indexOf('34') >= 0 ? 'h34' : 'h25');
    }
    function bandLabel() {
      if (isLyra) return parseInt(S.width, 10) <= 120 ? '90/100/120' : parseInt(S.width, 10) <= 160 ? '140/150/160' : '180/200';
      var b = bandFor(S.dimspec ? S.dimspec.baseW : S.width);
      if (!b) return null;
      return b.widths[0] === '90' ? '90/100/120' : (b.widths[0] === '140' || b.widths[0] === '160') ? '140/150/160' : '180/200';
    }
    /* La largeur que la tete AURA une fois posee sur CE lit-la.
       ⚠️ Deux options d'Olympus la changent, et les ignorer ferait mentir la
          ligne : « Tete etendue (+44 cm) » ajoute 44 cm, « Largeur reduite au
          cadre » supprime le debord. Une largeur juste pour huit modeles et
          fausse pour le neuvieme ne vaudrait pas mieux que pas de largeur. */
    function largeurTete(handle) {
      var base = parseInt(S.dimspec ? S.dimspec.baseW : S.width, 10);
      var deb = TETE_DEBORD[handle];
      if (!base || typeof deb !== 'number') return null;
      if (S.teteOpt['Largeur réduite au cadre']) deb = 0;
      if (S.teteOpt['Tête étendue (+44 cm)']) deb += 44;
      return { lit: base, deb: deb, total: base + deb };
    }
    function largeurTeteTxt(handle) {
      var l = largeurTete(handle);
      if (!l) return null;
      if (!l.deb) return l.total + ' cm — exactement la largeur du lit';
      return l.total + ' cm — le lit (' + l.lit + ' cm) plus ' + l.deb
        + ' cm, soit ' + (l.deb / 2) + ' cm de débord de chaque côté';
    }
    function appoints() {
      /* [{label, cents, id, prop}] — lignes ajoutées au panier */
      var out = [], bl = bandLabel(), rs = resolvedStab();
      /* support lombaire */
      if (!S.boxkit && rs && !rs.err) {
        var lsSel = twoSides() ? (S.lsL || S.lsR) : S.lsL;
        var lsOK = twoSides() ? [S.stabL, S.sameStab ? S.stabL : S.stabR].some(function (k) { return k && stabByKey[k].ls; })
          : (S.stabL && stabByKey[S.stabL].ls);
        if (lsSel && lsOK) {
          var lsDef = twoSides() ? V.ls.dual : V.ls[bandKeyForLS()] || V.ls.b2;
          var sides = twoSides() ? [S.lsL ? 'gauche' : null, S.lsR ? 'droit' : null].filter(Boolean).join(' + ') : null;
          out.push({ label: 'Support lombaire' + (sides ? ' (côté ' + sides + ')' : ''), cents: lsDef.price * 100, id: lsDef.variant });
        }
      }
      /* tête de lit */
      if (V.tete && V.tete.mode === 'vega') {
        if (S.vega.tete) { var vt = pickVar(V.tete.vega.tete, S.vega.tete); if (vt) out.push({ label: 'Tête de lit Vega · ' + S.vega.tete, cents: vt.cents, id: vt.id }); }
        if (S.vega.cadre) { var vc = pickVar(V.tete.vega.cadre, S.vega.cadre); if (vc) out.push({ label: 'Cadre premium · ' + S.vega.cadre, cents: vc.cents, id: vc.id }); }
        if (S.vega.lampes) { var vl = pickVar(V.tete.vega.lampes, 'Paire'); if (vl) out.push({ label: 'Lampes Vega', cents: vl.cents, id: vl.id }); }
        if (S.vega.pouf) { var vp = pickVar(V.tete.vega.pouf, S.vega.pouf); if (vp) out.push({ label: 'Pouf Vega · ' + S.vega.pouf, cents: vp.cents, id: vp.id }); }
      } else if (V.tete && (V.tete.mode === 'optional' || V.tete.mode === 'select') && S.tete && bl) {
        var t = null; (V.tete.catalog || []).forEach(function (x) { if (x.handle === S.tete) t = x; });
        if (t) {
          var gamme = V.tete.remise ? 'Gamme Select' : 'Standard';
          var tv = pickVar(t.variants, [S.teteTier || t.tiers[0].label, bl, gamme]);
          if (tv) {
            /* 🛑 CE QUI DECRIT LA TETE VA SUR LA LIGNE DE LA TETE. La matiere
               et la teinte etaient ecrites sur la ligne du LIT : l'atelier
               lisait la teinte d'un meuble sur la fiche d'un autre. */
            var pTete = {};
            var ltxt = largeurTeteTxt(S.tete);
            if (ltxt) pTete['Largeur de la tête'] = ltxt;
            /* 🛑 PAS DE MATIERE SUR LA LIGNE. Consigne du 20/09 : « la
               matiere d'une tete de lit, c'est celle de base sur l'image, donc
               ne mets rien ». Et la valeur qu'on ecrivait ici — « Athina /
               Luke / Hot Madison / cuir artificiel » — n'etait pas une
               matiere : c'etait une BANDE TARIFAIRE Akva, la meme qu'on vient
               de retirer partout ailleurs.
               ⚠️ Le choix de palier reste dans le configurateur la ou il change
                  le PRIX (Hugo : 678 EUR ou 888 EUR) ; il ne s'affiche plus. */
            if (S.teteCol) pTete['Teinte'] = S.teteCol;
            out.push({
              label: 'Tête de lit ' + t.label + (V.tete.remise ? ' (remise −308 € déduite)' : ''),
              cents: tv.cents, id: tv.id, tete: true, props: pTete
            });
          }
          Object.keys(S.teteOpt).forEach(function (k) {
            if (!S.teteOpt[k]) return;
            var ov = pickVar(V.tete.options.variants, k);
            if (ov) out.push({ label: 'Option tête · ' + k, cents: ov.cents, id: ov.id });
          });
        }
      }
      /* socle */
      /* 🛑 NE PAS « OPTIMISER » CETTE LIGNE EN SAUTANT LE SOCLE INCLUS. Je l'ai fait le
         14/09, en lisant `V.socle.inclus` comme « socle deja compris dans le prix de la
         variante, donc pas d'appoint ». C'est faux, et ca casse tout l'edifice :
           · la variante du Nordic (2 970 €) porte le prix Akva, socle DECOR compris ;
           · la boutique ne vend ce lit qu'en PLACAGE — « le decor n'a rien a faire ici, que
             ce soit socle plein ou tiroir c'est de toute facon placage » (14/09) ;
           · l'echange placage (+243 €) est donc TOUJOURS applique, et le prix annonce est
             « tout compris » : 3 213 €. C'est ce prix-la qui existe, pas 2 970 €.
         En sautant l'appoint, le configurateur ouvrait a 2 970 € — un prix qui n'est pas
         vendu — et l'ecart d'un deux-tiroirs passait de +300 a +543 €.
         ⚠️ Le +300 € est la preuve que le montage est juste : 3 513 − 3 213, soit exactement
         728 − 428 au tarif Akva p.32. Il tombe tout seul PARCE QUE le socle inclus est
         facture comme un echange. */
      if (S.socleType) {
        var sv = socleSwap(S.socleType);
        if (sv) out.push({ label: 'Socle ' + S.socleType.toLowerCase().replace('socle ', '') + ' (échange)', cents: sv.cents, id: sv.id });
      }
      if (S.facades) {
        var fv = facadesVar();
        if (fv) out.push({ label: 'Façades rembourrées', cents: fv.cents, id: fv.id });
      }
      if (S.socleSurMesure) { var sm = pickVar(V.socle.options, 'sur mesure');
        /* la hauteur est DANS le libelle : une ligne « hauteur sur mesure »
           sans hauteur ne dit pas ce qu'on fabrique. */
        if (sm) out.push({ label: 'Socle hauteur sur mesure'
          + (S.socleSmCm != null ? ' \u2014 ' + String(S.socleSmCm).replace('.', ',') + ' cm' : '')
          /* la tranche EST l'explication du prix : sans elle, le total bouge de
             plus de 75 € et le client croit a une erreur. */
          + (S._socleSmBrk ? ' (tranche ' + S._socleSmBrk + ')' : ''),
          cents: sm.cents, id: sm.id }); }
      /* pieds / surpiqûres / dimspec */
      if (S.pieds && V.pieds) { var pv = pickVar(V.pieds.variants, 'massif'); if (pv) out.push({ label: 'Pieds bois massif', cents: pv.cents, id: pv.id }); }
      if (S.surpiq && V.surpiqures) out.push({ label: 'Surpiqûres sur cadre', cents: V.surpiqures.price * 100, id: V.surpiqures.variant });
      if (S.dimspec) {
        var tdef = S.dimspec.tier === 2 ? V.dimspec.t2 : V.dimspec.t1;
        out.push({ label: 'Dimension sur mesure ' + S.dimspec.w + '×' + S.dimspec.l + ' cm', cents: tdef.price * 100, id: tdef.variant });
      }
      return out;
    }
    function deductions() {
      var out = [];
      if (S.ded.liner) out.push(V.deductions[0]);
      if (S.ded.dessus) out.push(V.deductions[1]);
      return out;
    }
    function dedCode() {
      if (S.ded.liner && S.ded.dessus) return V.dedCombo;
      if (S.ded.liner) return V.deductions[0].code;
      if (S.ded.dessus) return V.deductions[1].code;
      return null;
    }

    /* ── complétude ── */
    /* 🛑 UNE ETAPE NE PEUT PAS EXIGER CE QU'ON NE MONTRE PLUS.
       `socle` etait cochee par « une teinte de socle est choisie », `fin` par
       « une finition de cadre est choisie ». Les deux nuanciers sont masques
       depuis le 06/09 (les couleurs se choisissent en showroom, sur echantillon
       reel), et sans ce garde-fou les deux etapes restaient EN ATTENTE pour
       toujours — donc `complete()` restait faux, donc le bouton d'ajout au
       panier ne s'allumait jamais. Mesure : etape socle « attente » apres avoir
       choisi 30 cm, coche jamais posee dans le rail.
       Le drapeau est pose par la section, a cote de `lae_couleurs` : rendre les
       nuanciers rend aussi leur exigence. */
    function sansCouleur() {
      if (typeof window !== 'undefined' && window.__LAE_SANS_COULEUR === true) return true;
      /* 🛑 LE DRAPEAU N'EST PAS TOUJOURS EMIS — ON CONSTATE, ON NE CROIT PAS.
         Mesure du 07/09 sur les six /pages/configurer-* en ligne :
         `window.__LAE_SANS_COULEUR` vaut `undefined`, aucune balise <script> ne
         le pose. La section deployee masque ses nuanciers avec une variable
         Liquid `lae_couleurs` qu'elle n'assigne jamais (donc nil, donc faux) :
         elle cache les teintes sans le dire au moteur. Le moteur croyait donc
         qu'une couleur restait a choisir alors que la page n'en proposait
         aucune. On regarde l'etat REEL de la page.
         `[data-choix]` est la marque des controles de la PAGE : elle exclut les
         boutons homonymes du panneau moteur, hors ecran, qui existent toujours. */
      try {
        return !document.querySelector('[data-choix][data-act="soclecol"], [data-choix][data-act="cadre"]');
      } catch (e) { return false; }
    }
    function needCadre() { if (sansCouleur()) return false; return cfg.cadre && cfg.cadre.enabled && !S.cadre && !S.boxkit; }
    function needSocleCol() { if (sansCouleur()) return false; return cfg.socle && cfg.socle.enabled && !S.socleCol; }
    function needTeteInc() { return V.tete && V.tete.mode === 'included' && (V.tete.included || []).length > 0 && !S.teteInc; }
    /* Le socle n'a rien a decider quand le nuancier est masque ET que la hauteur
       est unique. `!HEIGHTS` = pas de hauteurs declarees : le moteur retombe sur
       les deux tranches de prix 25/30 et 34/37,5, donc un choix existe bel et
       bien. Le Lyra en a quatre : lui aussi garde son etape. */
    function socleSansObjet() { return sansCouleur() && !!HEIGHTS && HEIGHTS.length === 1; }
    function stepsDone() {
      var rs = resolvedStab();
      return {
        sys: !!(S.system && S.line), dim: !!((S.width && S.length) || S.dimspec),
        stab: S.boxkit || !!(rs && !rs.err && rs.col && (!twoSides() || S.sameStab || S.stabR)),
        fin: !needCadre(), socle: !needSocleCol(), tete: !needTeteInc()
      };
    }
    /* 🛑 UNE ETAPE QUI OFFRE UN CHOIX DOIT ETRE REPONDUE AVANT DE COMMANDER.
       `complete()` ne lisait que `stepsDone()` — ce que le MOTEUR sait resoudre — pendant que
       le sommaire lisait les temoins de ce que le CLIENT a touche. Deux notions de « fait »,
       et le panier suivait la plus laxiste : mesure du 11/09, avec `fin` et `tete` encore en
       « attente » le bouton affichait « Ajouter au panier » et le panier acceptait — la ligne
       partant avec « Coulissement des tiroirs : glissieres » que personne n'avait choisi.
       Les conditions ci-dessous sont exactement celles du sommaire. */
    function teteADecider() {
      if (!V.tete || V.tete.mode === 'none') return false;
      if (V.tete.mode === 'included' && (V.tete.included || []).length === 0) return false;
      if (V.tete.mode === 'vega') return false;          /* supplement : facultatif */
      return true;
    }
    /* Tarif p.34 : le choix glissieres/roulettes n'existe QUE sur les box standard.
       p.35 : sur les big box c'est roulettes d'office — rien a decider, rien a attendre. */
    function coulissementADecider() {
      var t = String(S.socleType || '').toLowerCase();
      return t.indexOf('box') >= 0 && t.indexOf('big box') < 0;
    }
    /* 🛑 LE TYPE DE SOCLE EST UNE DECISION, ET IL LUI FALLAIT UNE ETAPE.
       On demande a la PAGE si elle offre ce choix, plutot que de recopier ici la
       liste `SANS_SOCLETYPE = 'boxbed,carla,vega'` du Liquid : deux listes finissent
       toujours par diverger, et c'est le rendu qui fait foi. Meme methode que
       `sansCouleur()`, qui constate l'absence de commandes dans le document. */
    function socleTypeADecider() {
      /* 24/09 : on cherche la commande HORS du panneau moteur. Le moteur fabrique lui-même ses pastilles
         `socletype` dans [data-cf-mount] (caché) : la requête les trouvait toujours, et Boxbed, Carla, Vega
         — dont la fiche n'offre PAS ce choix (SANS_SOCLETYPE) — restaient bloqués à « Choisissez le type de
         socle », sans aucun moyen de répondre : impossible de les commander. */
      try { var t = document.querySelectorAll('[data-act="socletype"]');
            for (var i = 0; i < t.length; i++) { if (!t[i].closest('[data-cf-mount]')) return true; }
            return false; }
      catch (e) { return false; }
    }
    function complete() {
      var d = stepsDone();
      if (!(d.sys && d.dim && d.stab && d.fin && d.socle && d.tete && !!currentVariant())) return false;
      if (!socleSansObjet() && !S._socleVu) return false;
      /* ⚠️ Le sommaire et le panier partagent la meme regle — decision du 20/09.
         Une etape offerte doit donc etre repondue avant de commander, le type de
         socle comme les autres. C'est ce qui fait qu'un sommaire honnete ne
         devient pas un sommaire decoratif. */
      if (socleTypeADecider() && !S._socleTypeVu) return false;
      if (!S._finVu) return false;
      if (teteADecider() && !S._teteTouched) return false;
      if (coulissementADecider() && !S.coulissement) return false;
      if (!S._installVu) return false;
      return true;
    }

    /* ── rendu ── */
    function stepShell(i, title, summary, done, bodyHtml, open) {
      return '<section class="cf2__step' + (open ? ' is-open' : '') + (done ? ' is-done' : '') + '" data-step="' + i + '">' +
        '<button type="button" class="cf2__head" data-act="open" data-val="' + i + '" aria-expanded="' + (open ? 'true' : 'false') + '">' +
        '<span class="cf2__num">0' + (i + 1) + '</span><span class="cf2__t">' + esc(title) + '</span>' +
        '<span class="cf2__sum">' + (done && !open ? esc(summary || '') : '') + '</span>' +
        '<span class="cf2__chip">' + (done ? SVG_CHECK : '') + '</span>' +
        '<span class="cf2__arrow" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M8 10l4 4 4-4"/></svg></span></button>' +
        '<div class="cf2__body"' + (open ? '' : ' hidden') + '>' + bodyHtml +
        (i < 7 ? '<div class="cf2__nextrow"><button type="button" class="cf2__next" data-act="next">Continuer</button></div>' : '') +
        '</div></section>';
    }
    function pills(list, act, sel, extra) {
      var h = '<div class="cf2__pills">';
      list.forEach(function (it) {
        var v = it.v !== undefined ? it.v : it, label = it.label || it, dis = it.dis, why = it.why;
        h += '<button type="button" class="cf2__pill' + (sel === v ? ' is-on' : '') + '"' +
          (dis ? ' disabled data-why="' + esc(why || '') + '"' : '') +
          ' data-act="' + act + '" data-val="' + esc(v) + '"' + (extra ? ' ' + extra : '') +
          (it.tip ? ' data-tip="' + it.tip + '"' : '') +
          ' aria-pressed="' + (sel === v) + '">' + esc(label) +
          (it.d ? '<span class="cf2__pd">' + it.d + '</span>' : '') +
          (dis && why ? '<span class="cf2__why">' + SVG_LOCK + ' ' + esc(why) + '</span>' : '') + '</button>';
      });
      return h + '</div>';
    }

    function renderSystem() {
      var h = '';
      if (V.lines.length > 1) {
        h += '<div class="cf2__subk">Ligne de matelas</div>' +
          pills(V.lines.map(function (l) { return { v: l.key, label: l.label, tip: 'line:' + l.key }; }), 'line', S.line) +
          '<p class="cf2__hint">' + esc((line().mousse || []).length > 1 ? 'Mousse standard ou ferme au choix (étape Finitions).' : line().key.indexOf('-q') >= 0 ? 'Côtés en coupe droite · mousse ferme · pas de matelas combinés.' : '') + '</p>';
      }
      h += '<div class="cf2__syscards">';
      V.systems.forEach(function (s) {
        var al = sysAllowed(s.key), on = S.system === s.key;
        var minTxt = s.key === 'uno' ? 'de 90 à 200 cm' : s.key === 'dual' ? ((line().dualMin || s.min) + ' cm et plus') : s.min + ' cm et plus';
        h += '<button type="button" class="cf2__sys' + (on ? ' is-on' : '') + '"' + (al.ok ? '' : ' disabled') +
          ' data-act="system" data-val="' + s.key + '" data-tip="sys:' + s.key + '" aria-pressed="' + on + '">' +
          svgSys(s.key) + '<b>' + esc(s.label) + '</b><span>' + esc(s.sub) + '</span>' +
          '<i>' + esc(al.ok ? minTxt : al.why) + '</i></button>';
      });
      h += '</div>';
      if (twoSides()) h += '<p class="cf2__hint">' + esc(S.system === 'dual' ? 'Deux poches indépendantes avec diviseur : chaque dormeur règle son confort et sa température.' : 'Deux poches jumelées sous un même dessus : le confort par côté, sans séparation sensible au centre.') + '</p>';
      return h;
    }

    function renderDims() {
      if (!S.system) return '<p class="cf2__hint">Choisissez d’abord votre couchage.</p>';
      var h = '';
      if (isLyra) h += '<div class="cf2__subk">Hauteur de socle (elle fixe la table de prix Hardside)</div>' +
        (HEIGHTS ? heightPills(S.socleCm) : '');
      h += '<div class="cf2__subk">Largeur (cm)</div>' +
        pills(widthsAll().map(function (w) { var wi = widthInfo(w); return { v: w, label: w, dis: !wi.ok, why: wi.why, tip: 'width:' + w }; }), 'width', S.width);
      h += '<div class="cf2__subk">Longueur (cm)</div>';
      if (!S.width) h += '<p class="cf2__hint">Sélectionnez une largeur.</p>';
      else h += pills(lengthsFor(S.width).map(function (l) { return { v: l, label: l, tip: 'length:' + l }; }), 'length', S.length);
      if (!isLyra && V.dimspec) {
        h += '<button type="button" class="cf2__link" data-act="dimspec-toggle" data-tip="dimspec">' + (S.dimspec ? 'Dimension sur mesure : ' + S.dimspec.w + ' × ' + S.dimspec.l + ' cm — modifier' : 'Besoin d’une dimension sur mesure ?') + '</button>';
        if (S._dimspecOpen) {
          h += '<div class="cf2__dimspec"><p class="cf2__hint">Toute dimension jusqu’à 240 × 240 cm. Supplément : ' +
            euro(V.dimspec.t1.price * 100) + ' (' + esc(V.dimspec.t1.label) + ') · ' + euro(V.dimspec.t2.price * 100) + ' (' + esc(V.dimspec.t2.label) + ', ' + esc(V.dimspec.t2.cond) + '). Le prix de base est celui de la dimension standard supérieure.</p>' +
            '<div class="cf2__dsrow"><label>Largeur <input type="number" min="80" max="240" step="1" data-ds="w" value="' + (S.dimspec ? S.dimspec.w : '') + '"></label>' +
            '<label>Longueur <input type="number" min="180" max="240" step="1" data-ds="l" value="' + (S.dimspec ? S.dimspec.l : '') + '"></label>' +
            '<button type="button" class="cf2__btn2" data-act="dimspec-apply">Appliquer</button>' +
            (S.dimspec ? '<button type="button" class="cf2__btn2" data-act="dimspec-clear">Retirer</button>' : '') + '</div>' +
            '<p class="cf2__err2" data-ds-err hidden></p></div>';
        }
      }
      return h;
    }

    function stabScale(side, sel) {
      var h = '<div class="cf2__stabwrap" data-side="' + side + '">';
      h += '<div class="cf2__famrow">' +
        pills([{ v: 'fibres', label: 'Fibres F0–F8', tip: 'fam-fibres' }, { v: 'ergo', label: 'Ergo / F-Ergo', tip: 'fam-ergo' }], 'fam-' + side, sel && famOf(sel) === 'ergo' ? 'ergo' : 'fibres') + '</div>';
      var fam = (S['_fam' + side]) || (sel ? famOf(sel) : 'fibres');
      var list = stabsFor().filter(function (s) { return s.fam === fam; });
      h += pills(list.map(function (s) { return { v: s.key, label: s.key, tip: 'stab:' + side + ':' + s.key }; }), 'stab-' + side, sel);
      if (sel && stabByKey[sel]) h += '<p class="cf2__stabhint">' + esc(stabByKey[sel].hint) + '</p>';
      /* support lombaire du côté */
      var lsable = sel && stabByKey[sel].ls;
      if (S.system && !S.boxkit) {
        var bk = bandKeyForLS(), price = twoSides() ? V.ls.dual.price : ((V.ls[bk] || V.ls.b2).price);
        var on = side === 'L' ? S.lsL : S.lsR;
        h += '<button type="button" class="cf2__opt' + (on ? ' is-on' : '') + '"' + (lsable ? '' : ' disabled') +
          ' data-act="ls-' + side + '" data-tip="ls:' + side + '"><span class="cf2__box">' + (on ? SVG_CHECK : '') + '</span>' +
          '<span>Support lombaire' + (lsable ? '' : ' — existe en F3 à F7') + '</span>' +
          '<em>+ ' + euro(price * 100) + (twoSides() ? ' (forfait deux-matelas)' : '') + '</em></button>';
      }
      return h + '</div>';
    }
    function renderStab() {
      if (S.boxkit) return '<p class="cf2__hint">Boxkit sans matelas : pas de stabilisation à choisir. (Cadre, socle et plaques inclus — tête de lit et pieds en option.)</p>';
      if (!S.system) return '<p class="cf2__hint">Choisissez d’abord votre couchage.</p>';
      var h = '';
      if (!twoSides()) h += stabScale('L', S.stabL);
      else {
        h += '<button type="button" class="cf2__opt' + (S.sameStab ? ' is-on' : '') + '" data-act="samestab" data-tip="opt:samestab">' +
          '<span class="cf2__box">' + (S.sameStab ? SVG_CHECK : '') + '</span><span>Même confort des deux côtés</span></button>';
        if (S.sameStab) h += stabScale('L', S.stabL);
        else {
          h += '<div class="cf2__sides"><div><div class="cf2__sidek">Côté gauche</div>' + stabScale('L', S.stabL) + '</div>' +
            '<div><div class="cf2__sidek">Côté droit</div>' + stabScale('R', S.stabR) + '</div></div>';
          var rs = resolvedStab();
          if (rs && rs.err) h += '<p class="cf2__err2">' + esc(rs.err) + '</p>';
          else if (rs && rs.mixed) h += '<p class="cf2__reskey">Degré résultant ≈ <b>' + esc(rs.resKey) + '</b> — ' + esc(V.mix.hint) + '</p>';
        }
      }
      return h;
    }

    /* rangement par MATIERE : les nuanciers Akva melangent tissus Athina, Luke, Hot Madison,
       cuirs artificiels et bois/decor. Les separer rend le choix lisible (demande utilisatrice). */
    function familleDe(nom) {
      var v = (nom || '').toLowerCase();
      if (/^athina/.test(v)) return 'Athina';
      if (/^luke/.test(v)) return 'Luke';
      if (/madison/.test(v)) return 'Hot Madison';
      if (/beech|maple|chestnut|oak|h\u00eatre|ch\u00eane|placage|decor|d\u00e9cor|concrete|antracite|mirror|miroir/.test(v)) return 'Bois & d\u00e9cor';
      return 'Cuir artificiel';
    }
    function swatches(group, act, sel) {
      var cols = group.colors || [];
      var fams = [], parFam = {};
      cols.forEach(function (c) {
        var f = familleDe(c.name);
        if (!parFam[f]) { parFam[f] = []; fams.push(f); }
        parFam[f].push(c);
      });
      if (fams.length > 1) {
        var out = '';
        fams.forEach(function (f) {
          out += '<div class="cf2__fam">' + esc(f) + ' <i>(' + parFam[f].length + ')</i></div>' +
            swatchRow(parFam[f], act, sel);
        });
        return out;
      }
      return swatchRow(cols, act, sel);
    }
    function swatchRow(list, act, sel) {
      var h = '<div class="cf2__sws">';
      (list || []).forEach(function (c) {
        h += '<button type="button" class="cf2__sw' + (sel === c.name ? ' is-on' : '') + '" data-tip="sw:' + act + ':' + esc(c.name) + '" data-act="' + act + '" data-name="' + esc(c.name) + '" data-url="' + esc(c.url) + '" title="' + esc(c.name) + '" aria-pressed="' + (sel === c.name) + '" style="background-image:url(' + esc(c.url) + '&width=120)"></button>';
      });
      return h + '</div>';
    }
    function renderFin() {
      var h = '<div class="cf2__live"><span class="cf2__lived"></span>' +
        '<div><b>Chaque couleur s\u2019applique en direct sur la maquette 3D</b>' +
        '<i>Cliquez une pastille : le lit se recolore imm\u00e9diatement \u00e0 gauche.</i></div>' +
        '<button type="button" class="cf2__livebtn" data-act="show3d">Voir la maquette</button></div>';
      if ((CADRE_GRP.colors || []).length && !S.boxkit) {
        h += '<div class="cf2__subk">' + esc(V.cadreSource === 'socle' ? 'Bois du cadre' : (cfg.cadre.label || 'Cadre')) + (S.cadre ? ' \u2014 <b>' + esc(S.cadre) + '</b>' : '') + '</div>' + swatches(CADRE_GRP, 'cadre', S.cadre);
      }
      var l = line();
      if ((l.mousse || []).length > 1) h += '<div class="cf2__subk">Mousse du cadre</div>' + pills(l.mousse.map(function (m) { return { v: m, label: m, tip: 'mousse' }; }), 'mousse', S.mousse || l.mousse[0]);
      h += '<div class="cf2__subk">Revêtement (inclus, au choix)</div>' +
        pills((V.finitions.revetements || []).map(function (r) { return { v: r, label: r, tip: 'revet:' + r }; }), 'revet', S.revetement);
      var teteChosen = !!(S.tete || S.teteInc || (V.tete && V.tete.mode === 'vega' && S.vega.tete));
      h += '<div class="cf2__subk">Matelas</div>' +
        pills(V.finitions.matelasType.choices.map(function (c) {
          var dis = c.indexOf('Allong') >= 0 && !teteChosen;
          return { v: c, label: c, dis: dis, why: dis ? 'Avec tête de lit uniquement' : '', tip: 'mattype' };
        }), 'mattype', S.matType);
      h += '<p class="cf2__hint">' + esc(V.finitions.diviseurInfo) + '</p>';
      return h;
    }

    /* 🛑 Le plafond suit le TYPE de socle, il ne s'ecrit pas en dur. La page
       l'annoncait deja sans pouvoir l'appliquer : « Miroir et cornieres alu :
       37,5 cm maximum ». Le Benti est au meme plafond (sa propre fiche le dit).
       Les autres montent a 46. */
    var SM_MIN = 10, SM_MAX = 46, SM_MAX_BAS = 37.5, SM_PAS = 0.5;
    function smMax() {
      var t = String(S.socleType || '');
      return (/miroir/i.test(t) || /benti/i.test(t)) ? SM_MAX_BAS : SM_MAX;
    }
    function smNb(t) {
      /* ⚠️ « 37,5 » s'ecrit avec une virgule en francais. `parseFloat('37,5')`
         rend 37 EN SILENCE : une hauteur fausse presentee comme valide. */
      t = String(t == null ? '' : t).trim().replace(',', '.').replace(/\s+/g, '');
      if (!t || !/^[0-9]+(\.[0-9]+)?$/.test(t)) return null;
      var n = parseFloat(t);
      return isNaN(n) ? null : n;
    }
    function smFmt(n) { return String(n).replace('.', ','); }
    function validateSocleSm(n) {
      if (n === null) return { err: 'Indiquez une hauteur en cm.' };
      var mx = smMax();
      if (n < SM_MIN || n > mx)
        return { err: 'Entre ' + smFmt(SM_MIN) + ' et ' + smFmt(mx) + ' cm'
                      + (mx === SM_MAX_BAS ? ' avec ce type de socle.' : '.') };
      var k = (n - SM_MIN) / SM_PAS;
      if (Math.abs(k - Math.round(k)) > 1e-6)
        return { err: 'Par pas de ' + smFmt(SM_PAS) + ' cm.' };
      return { cm: n };
    }
    function socleSmBlock() {
      var sm = pickVar(V.socle.options, 'sur mesure');
      if (!sm) return '';                     /* pas de porteur : on ne vend pas */
      var h = '<button type="button" class="cf2__link" data-act="socle-sm-toggle" data-tip="soclesm">'
        + (S.socleSurMesure && S.socleSmCm
            ? 'Hauteur sur mesure : ' + smFmt(S.socleSmCm) + ' cm \u2014 modifier'
            : 'Besoin d\u2019une autre hauteur de socle ?') + '</button>';
      if (!S._socleSmOpen) return h;
      return h + '<div class="cf2__dimspec"><p class="cf2__hint">De ' + smFmt(SM_MIN)
        + ' \u00e0 ' + smFmt(smMax()) + ' cm, par pas de ' + smFmt(SM_PAS)
        + ' cm. Suppl\u00e9ment : ' + euro(sm.cents)
        + ', ajout\u00e9 au prix de la tranche de hauteur sup\u00e9rieure.</p>'
        + '<div class="cf2__dsrow"><label>Hauteur <input type="text" inputmode="decimal" '
        + 'autocomplete="off" data-ssm value="' + (S.socleSmCm == null ? '' : smFmt(S.socleSmCm)) + '"></label>'
        + '<button type="button" class="cf2__btn2" data-act="socle-sm-apply">Appliquer</button>'
        + (S.socleSurMesure ? '<button type="button" class="cf2__btn2" data-act="socle-sm-clear">Retirer</button>' : '')
        + '</div><p class="cf2__err2" data-ssm-err hidden></p></div>';
    }

    function renderSocle() {
      var h = '';
      if (cfg.socle && cfg.socle.enabled) h += '<div class="cf2__subk">' + esc(cfg.socle.label || 'Coloris du socle') + (S.socleCol ? ' — <b>' + esc(S.socleCol) + '</b>' : '') + '</div>' + swatches(cfg.socle, 'soclecol', S.socleCol);
      if (!isLyra) h += heightBlock();
      /* La hauteur sur mesure s'ajoute A la tranche standard, elle ne la
         remplace pas : le tarif facture « +75 € sur la tranche de hauteur
         superieure », donc la tranche reste choisie.
         🛑 PAS de `if (!isLyra)` ici, contrairement a la hauteur standard : le
            Lyra porte bien « Hauteur sur mesure » dans `v2.socle.options`, et
            l'en priver aurait reconduit le defaut qu'on corrige. Le garde-fou
            est la DONNEE — `socleSmBlock()` rend une chaine vide s'il n'y a pas
            de porteur de variante — jamais le nom du modele. */
      h += socleSmBlock();
      h += '<div class="cf2__subk">Type de socle <span class="cf2__inc">' + esc(V.socle.includedLabel) + '</span></div>';
      var types = ['Socle placage', 'Socle miroir', 'Benti (aluminium)', 'Tiroirs 2 box decor', 'Tiroirs 2 box placage', 'Tiroirs 4 box decor', 'Tiroirs 4 box placage', 'Tiroirs 2-big box decor', 'Tiroirs 2-big box placage', 'Tiroirs 4-big box decor', 'Tiroirs 4-big box placage'];
      var bl = bandLabel();
      var items = [{ v: '', label: 'Décor (inclus)', dis: false, tip: 'socletype:' }];
      types.forEach(function (t) {
        var dis = false, why = '';
        if (V.socle.drawerForbidden && t.indexOf('Tiroirs') === 0) { dis = true; why = 'Pas de socle à tiroirs avec un Boxbed'; }
        else if (t.indexOf('miroir') >= 0 && S.socleH.indexOf('34') >= 0) { why = ''; }
        var sv = bl ? socleSwap(t) : null;
        if (!dis && bl && !sv) { dis = true; why = why || 'Indisponible dans cette largeur/hauteur'; }
        items.push({ v: t, label: t.replace('Socle ', '').replace('Tiroirs ', 'Tiroirs ') + (sv ? ' · +' + euro(sv.cents) : ''), dis: dis, why: why,
          tip: 'socletype:' + t });
      });
      h += pills(items, 'socletype', S.socleType || '');
      if ((S.socleType || '').indexOf('Tiroirs') === 0) {
        var fv = facadesVar();
        h += '<button type="button" class="cf2__opt' + (S.facades ? ' is-on' : '') + '" data-act="facades" data-tip="opt:facades"><span class="cf2__box">' + (S.facades ? SVG_CHECK : '') + '</span><span>Façades rembourrées</span><em>+ ' + (fv ? euro(fv.cents) : '') + '</em></button>';
      }
      if ((S.socleType || '').indexOf('Tiroirs') === 0) h += '<p class="cf2__hint">Astuce : sur la maquette 3D, <b>cliquez un tiroir pour l’ouvrir</b>.</p>';
      h += '<p class="cf2__hint">Le socle Décor est compris : son prix est déduit, celui du socle choisi est ajouté. Le montant affiché est la différence exacte. Miroir et cornières alu : 37,5 cm maximum.</p>';
      return h;
    }

    var TETE_PHOTO = {
      'tete-k2': 'k2', 'tete-mt-thomas': 'mt-thomas', 'tete-plateau': 'plateau', 'tete-olympus': 'olympus',
      'tete-anton': 'anton', 'tete-oskar': 'oskar', 'tete-hugo': 'hugo',
      'tete-mt-ventoux': 'mt-ventoux-standard', 'tete-mt-ventoux-comfort': 'mt-ventoux-comfort'
    };
    var PHOTO_BASE = mount.getAttribute('data-tetes') || '';
    /* Les tetes SCANNEES ne se colorent pas : leur matiere est celle du meuble
       reel, cuite dans le fichier. Decision du 29/08. On lit la meme table que la
       maquette 3D, sur le montage `[data-bed3d]`, pour que les deux ne puissent
       PAS diverger : une tete scannee cote 3D et coloriable cote formulaire, ce
       serait un nuancier qui ne fait rien. */
    var SCANS_TETE = (function () {
      try {
        var m = document.querySelector('[data-bed3d]');
        var b = m && m.getAttribute('data-tetes');
        return b ? JSON.parse(b) : {};
      } catch (e) { return {}; }
    })();
    function teteScannee(handle) {
      var k = TETE_PHOTO[handle];
      return !!(k && SCANS_TETE[k]);
    }
    function tetePhoto(handle) {
      var k = TETE_PHOTO[handle];
      return k && PHOTO_BASE ? PHOTO_BASE.replace('__KEY__', k) : null;
    }
    function noticeTete() {
      var def = (V.tete && V.tete.defaultHandle) || null, lab = '';
      (V.tete.catalog || []).forEach(function (x) { if (x.handle === def) lab = x.label; });
      return '<div class="cf2__notice"><b>La maquette montre la t\u00eate ' + (lab ? esc(lab) : 'recommand\u00e9e') +
        ' pour vous donner le rendu du mod\u00e8le.</b>' +
        '<span>Elle n\u2019est <u>pas comprise</u> dans le prix affich\u00e9 : elle ne s\u2019ajoute que si vous la choisissez ci-dessous.</span></div>';
    }
    function renderTete() {
      if (!V.tete || V.tete.mode === 'none') return '<p class="cf2__hint">Pas de tête de lit sur ce modèle.</p>';
      if (V.tete.mode === 'included') {
        var h0 = '<p class="cf2__hint">La tête de lit est <b>incluse</b> avec ce modèle.</p>';
        if ((V.tete.included || []).length) h0 += '<div class="cf2__subk">Choisissez-la</div>' + pills(V.tete.included.map(function (x) { return { v: x, label: x, tip: 'teteinc:' + x }; }), 'teteinc', S.teteInc);
        return h0;
      }
      if (V.tete.mode === 'vega') {
        var hv = '<div class="cf2__subk">Tête de lit Vega (design Per Weiss)</div>' +
          pills([{ v: '', label: 'Sans' }, { v: 'Athina', label: 'Tissu · +' + euro(90000) }, { v: 'Re-wool', label: 'Re-wool · +' + euro(184500) }, { v: 'Noir / blanc', label: 'Cuir noir/blanc · +' + euro(229000) }], 'vegatete', S.vega.tete || '');
        return hv;
      }
      var bl = bandLabel();
      var h = noticeTete() + pills([{ v: '', label: 'Sans tête de lit', tip: 'tete:' }], 'tete', S.tete || '');
      h += '<div class="cf2__tetes">';
      (V.tete.catalog || []).forEach(function (t) {
        var tier0 = t.tiers[0], price = bl ? tier0.prices[bl === '90/100/120' ? 0 : bl === '140/150/160' ? 1 : 2] : tier0.prices[0];
        var shown = V.tete.remise ? price - V.tete.remise : price;
        var on = S.tete === t.handle;
        h += '<button type="button" class="cf2__tete' + (on ? ' is-on' : '') + '" data-act="tete" data-val="' + esc(t.handle) + '" data-tip="tete:' + esc(t.handle) + '" aria-pressed="' + on + '">' +
          '<b>' + esc(t.label) + '</b><span>' + esc(t.type) + '</span><em>+ ' + euro(shown * 100) + (V.tete.remise ? ' <i>(−308 € déduits)</i>' : '') + '</em></button>';
      });
      h += '</div>';
      if (S.tete) {
        var t = null; (V.tete.catalog || []).forEach(function (x) { if (x.handle === S.tete) t = x; });
        var ph = tetePhoto(S.tete);
        if (ph) h += '<figure class="cf2__photo"><img src="' + ph + '" alt="' + esc(t ? t.label : '') + '" loading="lazy">' +
          '<figcaption>Photo officielle Akva \u2014 ' + esc(t ? t.label : '') + '</figcaption></figure>';
        if (t && t.tiers.length > 1) h += '<div class="cf2__subk">Matière</div>' + pills(t.tiers.map(function (x, i) {
          var p = bl ? x.prices[bl === '90/100/120' ? 0 : bl === '140/150/160' ? 1 : 2] : x.prices[0];
          return { v: x.label, label: x.label + ' · ' + euro((V.tete.remise ? p - 308 : p) * 100) };
        }), 'tetetier', S.teteTier || t.tiers[0].label);
        /* couleur de la tete : le nuancier depend de la matiere du tier (bois -> socle, textile -> cadre) */
        var tierLab = S.teteTier || t.tiers[0].label;
        var woodTier = /d\u00e9cor|placage|h\u00eatre|ch\u00eane/i.test(tierLab);
        var grp = woodTier ? (cfg.socle || {}) : (cfg.cadre || {});
        if ((grp.colors || []).length && !teteScannee(S.tete)) {
          h += '<div class="cf2__subk">Couleur de la t\u00eate' + (S.teteCol ? ' \u2014 <b>' + esc(S.teteCol) + '</b>' : '') + '</div>' +
            swatches(grp, 'tetecol', S.teteCol) +
            '<p class="cf2__hint">' + (woodTier ? 'Teintes bois et d\u00e9cor' : 'Tissus Athina et cuirs') + ' \u2014 la t\u00eate se colore en direct sur la maquette 3D.</p>';
        }
        /* 🛑 LA LARGEUR SE DIT A L'ECRAN, PAS SEULEMENT SUR LA FACTURE.
           Elle depend du lit ET des options : elle se recalcule a chaque
           passage plutot que de s'ecrire une fois pour toutes. */
        var _ltxt = largeurTeteTxt(S.tete);
        if (_ltxt) h += '<p class="cf2__hint"><b>Largeur une fois posée : '
          + esc(_ltxt) + '.</b></p>';
        if (teteScannee(S.tete)) {
          h += '<p class="cf2__hint">Cette tête est rendue à partir d’un scan du meuble réel : '
             + 'sa matière et sa teinte sont celles du modèle Akva, elles ne se changent pas.</p>';
        }
        var opts = TETE_OPTS[S.tete] || {};
        var rows2 = [];
        if (opts.surpiqures) rows2.push({ k: 'Surpiqûres', dis: !!S.teteOpt[boutonKey()], why: 'Incompatible avec les boutons' });
        if (opts.boutons && bl) rows2.push({ k: opts.boutons[bl === '90/100/120' ? 0 : bl === '140/150/160' ? 1 : 2], dis: !!S.teteOpt['Surpiqûres'], why: 'Incompatible avec les surpiqûres' });
        if (opts.hauteur) rows2.push({ k: 'Hauteur spéciale' });
        if (opts.etendue) rows2.push({ k: 'Tête étendue (+44 cm)', dis: !!S.teteOpt['Largeur réduite au cadre'], why: 'Incompatible avec la largeur réduite' });
        if (opts.reduite) rows2.push({ k: 'Largeur réduite au cadre', prix: 175, dis: !!S.teteOpt['Tête étendue (+44 cm)'], why: 'Incompatible avec la tête étendue' });
        if (opts.coussins) rows2.push({ k: 'Coussins (la paire)' });
        if (rows2.length) {
          h += '<div class="cf2__subk">Options de la tête</div>';
          rows2.forEach(function (r) {
            var ov = pickVar(V.tete.options.variants, r.k), on2 = !!S.teteOpt[r.k];
            var prixTxt = ov ? euro(ov.cents) : (r.prix ? euro(r.prix * 100) : '');
            h += '<button type="button" class="cf2__opt' + (on2 ? ' is-on' : '') + '"' + (r.dis ? ' disabled' : '') +
              ' data-act="teteopt" data-val="' + esc(r.k) + '" data-tip="topt:' + esc(r.k) + '"><span class="cf2__box">' + (on2 ? SVG_CHECK : '') + '</span>' +
              '<span>' + esc(r.k) + (r.dis ? ' — ' + r.why : '') + '</span><em>+ ' + prixTxt + '</em></button>';
          });
        }
      }
      return h;
    }
    function boutonKey() {
      var opts = TETE_OPTS[S.tete] || {}, bl = bandLabel();
      return (opts.boutons && bl) ? opts.boutons[bl === '90/100/120' ? 0 : bl === '140/150/160' ? 1 : 2] : '__none__';
    }

    function renderOptions() {
      var h = '<div class="cf2__notice"><b>Ce que la maquette met en sc\u00e8ne n\u2019est pas tout factur\u00e9.</b>' +
        '<span>Tables de chevet, lampes, tapis et pouf sont l\u00e0 pour le rendu \u2014 <u>non compris</u> dans le prix. ' +
        'Seules les options coch\u00e9es ci-dessous s\u2019ajoutent \u00e0 votre lit.</span></div>';
      if (isBoxkitable) {
        h += '<button type="button" class="cf2__opt' + (S.boxkit ? ' is-on' : '') + '" data-act="boxkit" data-tip="boxkit"><span class="cf2__box">' + (S.boxkit ? SVG_CHECK : '') + '</span><span>Boxkit — le lit sans matelas</span><em>cadre + socle + plaques</em></button>' +
          '<p class="cf2__hint">Pour installer votre propre matelas : le Boxbed complet, sans la partie eau.</p>';
      }
      if (V.surpiqures && !S.boxkit) h += '<button type="button" class="cf2__opt' + (S.surpiq ? ' is-on' : '') + '" data-act="surpiq" data-tip="opt:surpiq"><span class="cf2__box">' + (S.surpiq ? SVG_CHECK : '') + '</span><span>Surpiqûres sur cadre</span><em>+ ' + euro(V.surpiqures.price * 100) + '</em></button>';
      if (V.pieds) h += '<button type="button" class="cf2__opt' + (S.pieds ? ' is-on' : '') + '" data-act="pieds" data-tip="opt:pieds"><span class="cf2__box">' + (S.pieds ? SVG_CHECK : '') + '</span><span>Pieds bois massif (hêtre ou chêne)</span><em>+ ' + euro(V.pieds.price * 100) + '</em></button>';
      if (V.tete && V.tete.mode === 'vega') {
        h += '<div class="cf2__subk">Vega — suppléments dédiés</div>';
        h += pills([{ v: '', label: 'Cadre tissu (inclus)' }, { v: 'Re-wool', label: 'Cadre Re-wool · +' + euro(89800) }, { v: 'Noir / blanc', label: 'Cadre cuir · +' + euro(416000) }], 'vegacadre', S.vega.cadre || '');
        h += '<button type="button" class="cf2__opt' + (S.vega.lampes ? ' is-on' : '') + '" data-act="vegalampes" data-tip="opt:vegalampes"><span class="cf2__box">' + (S.vega.lampes ? SVG_CHECK : '') + '</span><span>Lampes intégrées</span><em>+ ' + euro(132300) + '</em></button>';
        h += pills([{ v: '', label: 'Sans pouf', tip: 'opt:pouf' }, { v: 'Athina', label: 'Pouf tissu · +' + euro(62000) }, { v: 'Re-wool', label: 'Pouf Re-wool · +' + euro(80500) }, { v: 'Noir / blanc', label: 'Pouf cuir · +' + euro(81800) }], 'vegapouf', S.vega.pouf || '');
      }
      (V.deductions || []).forEach(function (d) {
        var on = S.ded[d.key];
        h += '<button type="button" class="cf2__opt' + (on ? ' is-on' : '') + '" data-act="ded" data-val="' + d.key + '" data-tip="ded-' + d.key + '"><span class="cf2__box">' + (on ? SVG_CHECK : '') + '</span><span>' + esc(d.label) + '</span><em>− ' + euro(d.amount * 100) + '</em></button>';
      });
      if ((V.deductions || []).length) h += '<p class="cf2__hint">Les remises sont déjà comptées dans le prix affiché.</p>';
      return h;
    }

    function renderRecap() {
      var v = currentVariant(), rs = resolvedStab();
      if (!v) return '<p class="cf2__hint">Complétez les étapes pour voir votre récapitulatif.</p>';
      var h = '<ul class="cf2__recap">';
      h += li('Couchage', sysDef(S.system).label + ' · ' + line().label);
      h += li('Dimension', S.dimspec ? (S.dimspec.w + ' × ' + S.dimspec.l + ' cm (sur mesure)') : (S.width + ' × ' + S.length + ' cm'));
      if (!S.boxkit) h += li('Confort', twoSides() && !S.sameStab ? ('gauche ' + S.stabL + ' · droit ' + S.stabR + ' (résultant ' + rs.resKey + ')') : S.stabL);
      if (S.cadre) h += li('Cadre', S.cadre + (S.mousse ? ' · mousse ' + S.mousse.toLowerCase() : ''));
      if (S.socleCol) h += li('Socle', S.socleCol + ' · ' + (S.socleType || 'Décor inclus') + ' · ' + (S.socleCm ? hLabel(S.socleCm) : S.socleH));
      if (S.revetement) h += li('Revêtement', S.revetement + ' · matelas ' + S.matType.toLowerCase());
      if (S.teteInc) h += li('Tête de lit', S.teteInc + ' (incluse)');
      /* 🛑 L'installation manquait AUSSI a cette liste : le client relisait
         sa configuration sans y voir la prestation qu'il venait de choisir. */
      if (INSTALL && INSTALL.id) h += li('Installation',
        (INSTALL.kmReel || INSTALL.km) + ' km depuis Gigean'
        + (INSTALL.adresse ? ' · ' + INSTALL.adresse : ''));
      h += '</ul>';
      var ap = appoints();
      h += '<div class="cf2__lines"><div class="cf2__line"><span>' + esc(cfg.model ? 'Lit ' + cfg.model : 'Lit à eau') + ' · configuration</span><b>' + euro(v.cents) + '</b></div>';
      ap.forEach(function (a) { h += '<div class="cf2__line"><span>' + esc(a.label) + '</span><b>+ ' + euro(a.cents) + '</b></div>'; });
      /* 🛑 L'INSTALLATION N'EST NI UNE VARIANTE, NI UN APPOINT, NI UNE REMISE :
         elle vit dans `INSTALL` et n'apparaissait donc dans AUCUNE des trois
         listes que ce bloc enumere. Sans cette ligne, le bandeau dirait
         3 390 EUR pendant que le recapitulatif detaillerait 2 970. */
      if (INSTALL && typeof INSTALL.prix === 'number') {
        h += '<div class="cf2__line"><span>' + esc('Installation à domicile · '
          + (INSTALL.kmReel || INSTALL.km) + ' km') + '</span><b>+ '
          + euro(INSTALL.prix * 100) + '</b></div>';
      }
      deductions().forEach(function (d) { h += '<div class="cf2__line is-ded"><span>' + esc(d.label) + '</span><b>− ' + euro(d.amount * 100) + '</b></div>'; });
      h += '</div>';
      h += '<details class="cf2__inc2"><summary>Ce que comprend votre lit</summary><ul>' +
        (V.inclus || []).map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul></details>';
      if (V.notice) h += '<p class="cf2__hint">' + esc(V.notice) + '</p>';
      return h;
    }
    function li(k, v) { return '<li><span>' + esc(k) + '</span><b>' + esc(v) + '</b></li>'; }

    var STEPS = [
      { t: 'Votre couchage', r: renderSystem, done: function () { return stepsDone().sys; }, sum: function () { return S.system ? sysDef(S.system).label + ' · ' + line().label : ''; } },
      { t: 'Dimensions', r: renderDims, done: function () { return stepsDone().dim; }, sum: function () { return S.dimspec ? S.dimspec.w + ' × ' + S.dimspec.l + ' cm' : (S.width && S.length ? S.width + ' × ' + S.length + ' cm' : ''); } },
      { t: 'Confort & stabilisation', r: renderStab, done: function () { return stepsDone().stab; }, sum: function () { if (S.boxkit) return 'Boxkit (sans matelas)'; var rs = resolvedStab(); return rs && !rs.err && S.stabL ? (twoSides() && !S.sameStab ? S.stabL + ' / ' + (S.stabR || '—') : S.stabL) : ''; } },
      { t: 'Cadre', r: renderFin, done: function () { return stepsDone().fin; }, sum: function () { return [S.cadre, S.revetement].filter(Boolean).join(' · '); } },
      { t: 'Socle', r: renderSocle, done: function () { return stepsDone().socle; }, sum: function () { return [S.socleCol, S.socleType || (S.socleCol ? 'Décor' : '')].filter(Boolean).join(' · '); } },
      { t: 'Tête de lit', r: renderTete, done: function () { return stepsDone().tete; }, sum: function () { if (S.teteInc) return S.teteInc + ' (incluse)'; if (S.tete) { var t = ''; (V.tete.catalog || []).forEach(function (x) { if (x.handle === S.tete) t = x.label; }); return t; } if (V.tete && V.tete.mode === 'vega' && S.vega.tete) return 'Vega · ' + S.vega.tete; return V.tete && V.tete.mode === 'included' ? 'Incluse' : 'Sans'; } },
      { t: 'Options', r: renderOptions, done: function () { return true; }, sum: function () { var n = appoints().length + deductions().length; return n ? n + ' ligne(s)' : 'Aucune'; } },
      { t: 'Récapitulatif', r: renderRecap, done: function () { return complete(); }, sum: function () { return ''; } }
    ];

    var guideUrl = mount.getAttribute('data-guide') || '';
    function build() {
      var h = '<div class="cf2">';
      STEPS.forEach(function (st, i) { h += stepShell(i, st.t, st.sum(), st.done(), st.r(), S.open === i); });
      h += '</div>';
      mount.innerHTML = h;
    }

    /* ⚠️ `sansInstall` : le prix PLANCHER et les ECARTS de vignette doivent
       ignorer l'installation. Un « a partir de » qui contient 420 EUR de pose
       ne se compare plus d'un lit a l'autre — mesure du 20/09 : « 3 390 EUR · a
       partir de · choisissez la dimension » sur un lit sans dimension choisie.
       Et un ecart « + 328 EUR » calcule avec l'installation d'un cote et sans
       de l'autre serait faux. Decision de l'utilisatrice : le plancher reste le
       LIT SEUL. */
    function totals(sansInstall) {
      var v = currentVariant(), t = 0, ded = 0;
      if (v) { t = v.cents; appoints().forEach(function (a) { t += a.cents; }); }
      /* 🛑 L'INSTALLATION ENTRE DANS LE TOTAL. Signalement du 20/09 : « quand tu
         mets l'installation c'est ajoute au panier mais tu le vois pas dans le
         prix du lit directement, c'est dommage ». Exact : elle n'est pas un
         `appoint`, elle vit dans `INSTALL`, et aucun total ne la regardait. Le
         bandeau montrait le lit seul et le client decouvrait le supplement au
         panier — le contraire de ce que ce configurateur promet.
         ⚠️ On teste la presence avant d'additionner : un `undefined` ajoute a un
            total rend NaN, et un prix NaN s'AFFICHE au lieu de planter. */
      if (!sansInstall && v && INSTALL && typeof INSTALL.prix === 'number') t += INSTALL.prix * 100;
      deductions().forEach(function (d) { ded += d.amount * 100; });
      return { total: t, ded: ded, net: Math.max(0, t - ded) };
    }
    /* 🛑 LE PRIX D'OUVERTURE DOIT ETRE CELUI DU LIT HABILLE. `PLANCHER` ne
       regarde que les variantes du LIT : il ignore les appoints, dont la tete
       attitree desormais incluse d'office. Le bandeau ouvrait donc a 2 738 €
       alors que la configuration de depart en vaut 3 416 — un prix qui montait
       tout seul des la premiere dimension choisie, ce qui est exactement la
       mauvaise surprise qu'on veut eviter.
       `prixHypothese({})` complete l'etat manquant (plus petite bande, uno,
       premier palier) et passe par `totals()`, donc les appoints comptent. */
    function prixHypothese(mut) {
      var direct = tryNet(mut || {});
      if (direct !== null) return direct;
      var f0 = null;
      V.stabs.forEach(function (x) { if (!f0 && x.fam === 'fibres') f0 = x.key; });
      var sources = (V.lyraRows || []).length
        ? V.lyraRows.map(function (r) {
            return { widths: r.widths || [], lengths: r.lengths || [], system: r.system };
          })
        : (V.bands || []);
      for (var i = 0; i < Math.max(1, sources.length); i++) {
        var b = sources[i] || {};
        var m2 = {};
        if (!S.system) m2.system = b.system || 'uno';
        if (!S.width && (b.widths || []).length) m2.width = b.widths[0];
        if (!S.length && (b.lengths || []).length) m2.length = b.lengths[0];
        if (!S.stabL && f0) m2.stabL = f0;
        Object.keys(mut || {}).forEach(function (k) { m2[k] = mut[k]; });
        var essai = tryNet(m2);
        if (essai !== null) return essai;
      }
      return null;
    }
    function plancherAffiche() {
      try {
        var h = prixHypothese({});
        if (typeof h === 'number' && h > 0) return h;
      } catch (e) { }
      return PLANCHER;
    }

    var lastTotal = 0;
    var DES = '<small class="des">Dès</small> ';
    function refresh() {
      var v = currentVariant(), tt = totals(), c = complete();
      if (priceEl && v) priceEl.innerHTML = '<b>' + euro(tt.net) + '</b> · TTC, livraison offerte';
      if (bar) {
        var btn = bar.querySelector('[data-cf-add]'), tot = bar.querySelector('[data-cf-total]'), sub = bar.querySelector('[data-cf-sub]');
        if (tot) { var pl = plancherAffiche();
          if (v || pl === null) tot.textContent = v ? euro(tt.net) : '—';
          else tot.innerHTML = DES + euro(pl);   /* 29/10 : « Dès » DEVANT le prix, petit et discret */
          animateTick(tot, tt.net); }
        /* ⚠️ Le sous-titre doit dire ce que le total CONTIENT. Depuis que
           l'installation y entre, « TTC, livraison offerte » seul laissait
           croire qu'elle etait en plus. */
        /* 06/10 — REFONTE MOBILE : au téléphone, la configuration incomplète écrit seulement « à partir de ». La
           ligne d'état (190 px à 390, 174 à 360) recevait « à partir de · choisissez votre couchage » (233 px) :
           coupée en « …votre cou… », et redite mot pour mot par le bouton voisin, qui nomme déjà l'étape (règle
           truncation-strategy). L'ordinateur garde son texte, à l'identique. */
        if (sub) sub.textContent = v ? (tt.ded ? 'dont remise − ' + euro(tt.ded) + ' au paiement' : ((INSTALL && typeof INSTALL.prix === 'number') ? 'dont installation · ' + euro(INSTALL.prix * 100) : (appoints().length ? 'options incluses · ' + appoints().length + ' ligne(s)' : 'TTC, livraison offerte'))) : ((MQ_TEL && MQ_TEL.matches) ? 'TTC, livraison offerte' : ('TTC, livraison offerte · ' + prochaineEtape().toLowerCase()));
        if (btn) {
          /* 🛑 UN BOUTON MORT N'APPREND RIEN. Il etait `disabled` tant que la
             configuration n'etait pas complete : il annoncait « Choisissez la
             dimension » et ne repondait pas au clic. Signalement du 07/09 :
             « je peux pas cliquer sur choisissez la dimension quand ça propose ».
             Il reste donc vivant et devient un RACCOURCI vers l'etape qui manque. */
          btn.disabled = false;
          btn.textContent = c ? 'Ajouter au panier' : prochaineEtape();
          btn.setAttribute('data-cible-etape', c ? '' : prochaineCle());
          btn.classList.toggle('is-raccourci', !c);
        }
      }
      if (S.cadreUrl && bigsw) { bigsw.style.backgroundImage = 'url(' + S.cadreUrl + '&width=120)'; if (finK) finK.textContent = 'Finition cadre'; if (finN) finN.textContent = S.cadre; }
      else if (S.socleColUrl && bigsw && !S.cadreUrl) { bigsw.style.backgroundImage = 'url(' + S.socleColUrl + '&width=120)'; if (finK) finK.textContent = 'Finition socle'; if (finN) finN.textContent = S.socleCol; }
      /* pont vers l'ilot 3D (litaeau-bed3d) : etat utilisateur courant */
      try {
        var det = {
          width: S.width, length: S.length, system: S.system, boxkit: S.boxkit, socleH: S.socleH,
          socleCm: S.socleCm, layingPlus: LAYING, teteCol: S.teteCol ? { name: S.teteCol, url: S.teteColUrl } : null,
          vegaLampes: !!(S.vega && S.vega.lampes), vegaPouf: (S.vega && S.vega.pouf) || null,
          teteDefault: (V.tete && V.tete.defaultHandle) || null,
          cadre: S.cadre ? { name: S.cadre, url: S.cadreUrl } : null,
          socle: S.socleCol ? { name: S.socleCol, url: S.socleColUrl } : null,
          tete: S._teteTouched ? (S.tete || '') : undefined,
          teteInc: S.teteInc || null, vegaTete: (S.vega && S.vega.tete) || null,
          socleType: S.socleType || '', facades: !!S.facades,
          coulissement: S.coulissement || null,
          socleFin: S.socleFin || null,
          /* champs ignorés par l'îlot 3D, lus par le récit pour marquer ses vignettes
             « choisi » : sans ça le chapitre et le panneau se contredisent à l'écran */
          stabL: S.stabL || null, stabR: S.stabR || null, sameStab: !!S.sameStab,
          /* 🛑 LE SUPPORT LOMBAIRE — les quatre champs que la page attendait.
             `litaeau-conf-js` fait `bLs.disabled = !(ev.lsDispo === true)` :
             sans ce champ le bouton etait desactive EN PERMANENCE, meme en F5
             ou le tarif l'autorise (p.7 : LS de F3 a F7, 160 EUR). Mesure du
             09/09 : disabled=true, prix vide, sur toutes les fermetes.
             La regle n'est pas recopiee : ce sont `stabByKey[].ls` et `V.ls`,
             les memes sources que le calcul facture plus haut. */
          lsDispo: lsDispoNow(), lsPrix: lsPrixNow(),
          lsL: !!S.lsL, lsR: !!S.lsR,
          revetement: S.revetement || null, mousse: S.mousse || null,
          teteTier: S.teteTier || null, socleColName: S.socleCol || null,
          cadreName: S.cadre || null, ligne: S.line || null,
          /* options : la page les propose desormais elle-meme, elle a besoin de savoir
             lesquelles sont actives pour marquer ses propres cases */
          surpiqOn: !!S.surpiq, piedsOn: !!S.pieds, boxkitOn: !!S.boxkit,
          dedLiner: !!(S.ded && S.ded.liner), dedDessus: !!(S.ded && S.ded.dessus),
          teteOpts: Object.keys(S.teteOpt || {}).filter(function (k) { return S.teteOpt[k]; }),
          /* largeur de la tete : standard (+24 cm), reduite au cadre, ou etendue (+44 cm) */
          teteLargeur: S.teteOpt['Largeur r\u00e9duite au cadre'] ? 'reduite'
            : (S.teteOpt['T\u00eate \u00e9tendue (+44 cm)'] ? 'etendue' : 'standard')
        };
        /* memorise pour l'ilot 3D charge a la demande : monte apres coup, il repart de la
           config deja choisie au lieu d'attendre le prochain refresh() */
        /* 🛑 L'ETAT DES ETAPES — LE CHAMP QUI MANQUAIT.
           Les deux sommaires (le rail de gauche, celui du corps) cochent leurs
           pastilles en lisant `detail.etapes`. Le moteur ne l'a JAMAIS emis : le
           refleteur commence par `if (!e || !e.etapes) return;`, donc il sortait
           a chaque fois. Mesure du 06/09 : aucune coche apres avoir choisi une
           hauteur de socle, et un compteur fige a « 0 / 6 » sur toute la page.
           Vocabulaire impose par le refleteur : fait · attente · option · hors. */
        try {
          var _d = stepsDone();
          det.etapes = {
            sys: _d.sys ? 'fait' : 'attente',
            dim: _d.dim ? 'fait' : 'attente',
            stab: _d.stab ? 'fait' : 'attente',
            /* 🛑 UNE ETAPE SANS RIEN A DECIDER N'EST PAS « EN ATTENTE ».
               L'etape 04 de la page ne porte que la hauteur de socle et son
               nuancier. Les nuanciers sont masques (`lae_couleurs`), et quatre
               modeles sur six ont une hauteur FIXE (fiche Akva : Nordic Select
               34, Carla 37,5, Boxbed 34, Vega 25) : la page n'y rend alors AUCUN
               bouton — mesure du 07/09, `[data-choix]` = 0 dans `#etape-04`.
               `S._socleVu` ne pouvait donc jamais etre pose, et l'etape restait
               « attente » jusqu'au bout pendant que le bouton disait « Ajouter
               au panier ». Meme traitement que la tete : sans objet, on le dit. */
            socle: socleSansObjet() ? 'hors' : ((_d.socle && S._socleVu) ? 'fait' : 'attente'),
            fin: (_d.fin && S._finVu) ? 'fait' : 'attente',
            /* une tete qui n'existe pas sur ce modele n'est pas « en attente » :
               elle est sans objet, et le dire vaut mieux que la faire attendre */
            /* 🛑 « fait » AVANT D'AVOIR CHOISI. En mode catalogue, `needTeteInc()`
               rend false, donc l'etape naissait cochee : le sommaire annoncait
               une tete choisie alors que rien ne l'etait. Il faut un geste. */
            tete: (function () {
              if (!V.tete || V.tete.mode === 'none') return 'hors';
              /* incluse et non choisissable (Lyra) : rien a decider */
              if (V.tete.mode === 'included' && (V.tete.included || []).length === 0) return 'hors';
              if (_d.tete && S._teteTouched) return 'fait';
              /* 🛑 LE VEGA N'A AUCUN BOUTON DE TETE DANS L'ETAPE 06 DE LA PAGE.
                 Sa gamme lui est propre et se choisit dans le reglage detaille,
                 en bas : l'etape 06 ne rend qu'une note. Mesure du 07/09 sur
                 /pages/configurer-vega — `[data-choix][data-act="vegatete"]` = 0
                 dans `#etape-06`. « attente » y etait donc une attente sans
                 issue. La tete Vega est un supplement : elle est FACULTATIVE, et
                 « option » ne gonfle pas le compteur du sommaire. */
              if (V.tete.mode === 'vega') return 'option';
              return 'attente';
            })(),
            /* elle attend une reponse, pas un achat : « je monte moi-meme » est une reponse. */
            /* 🛑 L'ETAPE 05 EXISTAIT A L'ECRAN ET PAS DANS CETTE TABLE. Le choix
               etait pris, il etait facture (2 800 -> 3 128 EUR sur le Soft), l'en-tete
               l'affichait — et le sommaire ne le voyait pas. Son temoin est
               distinct de celui du socle : l'etape 04 porte la hauteur, la 05 le
               type. Cocher l'une parce qu'on a clique dans l'autre serait le meme
               mensonge, deplace d'un cran. */
            socletype: !socleTypeADecider() ? 'hors'
                       : (S._socleTypeVu ? 'fait' : 'attente'),
            install: S._installVu ? 'fait' : 'attente',
            /* le coulissement des tiroirs : sans objet hors box standard (tarif p.34/p.35) */
            coulissement: coulissementADecider() ? (S.coulissement ? 'fait' : 'attente') : 'hors',
            /* Le pouf du Vega : facultatif, donc `option` — il ne gonfle pas le
               compteur et ne bloque jamais le panier. `hors` sur les lits qui
               n'en ont pas au tarif : une etape sans objet se dit, elle
               n'attend pas. */
            pouf: (function () {
              if (!V.tete || !V.tete.vega || !V.tete.vega.pouf) return 'hors';
              return (S.vega && S.vega.pouf) ? 'fait' : 'option';
            })()
          };
        } catch (e2) { }
        /* 🛑 CE QUE LE CLIENT A TOUCHE. Sans ces temoins, la page cochait
           « 25 cm », « Ligth beech » et « Sans tête » avant qu'il ait rien fait :
           des reglages internes presentes comme ses decisions. */
        det.socleVu = !!S._socleVu;
        det.socleTypeVu = !!S._socleTypeVu;
        det.finVu = !!S._finVu;
        det.teteVu = !!S._teteTouched;
        /* 🛑 LES DEUX CLES QUE LE MODE LIT N'EMETTAIT PAS. `prochaineCle()` et
           `prochaineEtape()` existent depuis longtemps et fonctionnent ; elles
           n'etaient simplement jamais publiees. Consequence mesuree le 20/09 :
           `aria-current` n'etait pose nulle part (0 element sur toute la page),
           le raccourci du bandeau s'allumait en « Configuration complete » alors
           que le compteur disait « 1 / 7 », et son clic retombait sur
           `VERS[undefined]`. Le mode cadre, lui, les emettait — d'ou un Emma qui
           se comportait correctement pendant que les sept lits mentaient. */
        det.prochaineCle = prochaineCle();
        det.prochaineTxt = prochaineEtape();
        /* 🛑 LES CLES QUE `majCompris()` ATTEND DEPUIS TOUJOURS, ET QUI
           N'ETAIENT JAMAIS EMISES. `snippets/litaeau-conf-js.liquid` lit
           `e.installOn` pour devoiler « L'installation par nos techniciens » et
           masquer « Le montage reste a votre main », et `e.installKm` /
           `e.installEur` pour les chiffrer. Mesure du 20/09 : ZERO cle
           `/install/` dans `__LAE_DERNIER_CONFIG`, donc `pris` valait toujours
           false et la ligne restait masquee — pour toujours, pas en retard.
           ⚠️ `installChoisi` reveille un SECOND consommateur, la
              resynchronisation du basculeur (`conf-js:1642-1649`), qui sortait a
              sa premiere ligne depuis l'origine. */
        /* ⚠️ `installOn` dit CE QUE LE CLIENT A CHOISI, pas si une adresse
           existe deja. Ma premiere version lisait `INSTALL` — qui ne se
           remplit qu'apres le choix d'une adresse — et reveillait ainsi le
           bloc de resynchronisation (`litaeau-conf-js.liquid:1642-1649`) avec
           une valeur fausse : il decochait « par nos techniciens » au premier
           `lae:config` venu. MESURE : un client qui avait dit « je m'en
           occupe » ne pouvait PLUS choisir l'installation, le bouton ne
           reagissait pas. `S.installOn` est pose par l'acte `install`, donc
           des le clic. Et `majCompris()` sait deja quoi dire entre-temps :
           « adresse a renseigner ». */
        det.installOn = !!S.installOn;
        det.installChoisi = !!S._installVu;
        det.installKm = INSTALL ? (INSTALL.kmReel || INSTALL.km || 0) : 0;
        det.installEur = INSTALL ? (INSTALL.prix || 0) : 0;
        det.installAdresse = INSTALL ? (INSTALL.adresse || '') : '';
        window.__LAE_DERNIER_CONFIG = det;
        root.dispatchEvent(new CustomEvent('lae:config', { bubbles: true, detail: det }));
      } catch (e) { }
    }
    function animateTick(el2, val) {
      if (val === lastTotal) return; lastTotal = val;
      el2.classList.remove('is-tick'); void el2.offsetWidth; el2.classList.add('is-tick');
    }
    /* la CLE de l'etape qui bloque — le libelle seul ne permet pas d'y aller */
    /* 🛑 LE BOUTON NOMME L'ETAPE QUI MANQUE, TOUJOURS. Ces deux fonctions ne lisaient que
       `stepsDone()` ; depuis que le panier exige AUSSI un geste du client sur la finition, la
       tete, le coulissement et l'installation, elles tombaient sur « Completez votre
       configuration » — un libelle qui ne dit pas OU aller, et le raccourci ne menait alors
       nulle part. L'ordre suit celui de la page. */
    function etapesManquantes() {
      var d = stepsDone(), m = [];
      if (!d.sys) m.push(['sys', 'Choisissez votre couchage']);
      if (!d.dim) m.push(['dim', 'Choisissez la dimension']);
      if (!d.stab) m.push(['stab', 'Choisissez le confort']);
      if (!d.socle || (!socleSansObjet() && !S._socleVu)) m.push(['socle', 'Choisissez le socle']);
      if (socleTypeADecider() && !S._socleTypeVu) m.push(['socletype', 'Choisissez le type de socle']);
      /* la question du coulissement vit DANS l'etape 05 : elle y renvoie, et elle
         a desormais sa propre ligne de sommaire — elle etait obligatoire et
         invisible, ce qui est la pire combinaison. */
      if (coulissementADecider() && !S.coulissement) m.push(['coulissement', 'Glissières ou roulettes ?']);
      if (!d.fin || !S._finVu) m.push(['fin', 'Choisissez le revêtement']);
      if (!d.tete || (teteADecider() && !S._teteTouched)) m.push(['tete', 'Choisissez votre tête de lit']);
      if (!S._installVu) m.push(['install', 'Livraison : avec ou sans installation ?']);
      /* 05/10 — REFONTE MOBILE : AU TÉLÉPHONE, LA BARRE SUIT L'ORDRE DE LA PAGE. La fiche montre « 06 La tête de
         lit » AVANT « 07 Le revêtement » ; cette liste disait l'inverse. Mesuré (sondes/configurateur-parcours.js,
         Nordic, 390 × 844) : en suivant le bouton de la barre, on sautait l'étape 06 pour descendre à la 07, puis on
         remontait à la 06, puis on redescendait à la 08 — 9,2 écrans parcourus au lieu de 7,2 en descendant la page.
         Au téléphone seulement (`max-width: 749px`) : la tête passe devant le revêtement. Rien d'autre ne bouge —
         ni les étapes émises (`detail.etapes`), ni les libellés, ni l'ordinateur. */
      if (MQ_TEL && MQ_TEL.matches) {
        var iFin = -1, iTete = -1;
        m.forEach(function (x, i) { if (x[0] === 'fin') iFin = i; if (x[0] === 'tete') iTete = i; });
        if (iFin > -1 && iTete > iFin) { var t = m.splice(iTete, 1)[0]; m.splice(iFin, 0, t); }
      }
      return m;
    }
    /* la barre se repeint quand l'écran passe d'un côté à l'autre de 749 px (rotation, fenêtre) : son bouton
       nomme alors l'étape dans l'ordre du nouveau format, sans attendre le prochain choix */
    var MQ_TEL = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    if (MQ_TEL && MQ_TEL.addEventListener) MQ_TEL.addEventListener('change', function () { try { refresh(); } catch (x) { } });
    function prochaineCle() { var m = etapesManquantes(); return m.length ? m[0][0] : ''; }
    function prochaineEtape() {
      var m = etapesManquantes();
      return m.length ? m[0][1] : 'Complétez votre configuration';
    }
    /* plus d'avance automatique : changer un choix ne referme plus l'etape
       (l'utilisateur teste ses combinaisons en regardant la maquette). */

    /* ── cartes au survol : explication SPECIFIQUE de l'option + prix avec ce choix ── */
    var PAGE_OF = { topt: 'guide-tetes-de-lit', opt: 'guide-options', line: 'guide-matelas', length: 'guide-dimensions', revet: 'guide-revetements', sw: null, sys: 'guide-matelas', stab: 'guide-stabilisations', fam: 'guide-stabilisations', ls: 'guide-stabilisations', width: 'guide-dimensions', dimspec: 'guide-dimensions', mattype: 'guide-dimensions', socleh: 'guide-socles', socletype: 'guide-socles', mousse: 'guide-matelas', revetement: 'guide-revetements', tete: 'guide-tetes-de-lit', teteinc: 'guide-tetes-de-lit', boxkit: 'guide-options', ded: 'guide-options' };
    var SYS_TIP = {
      uno: { t: 'Un matelas', d: 'Une seule poche d\u2019eau sur toute la largeur : m\u00eame confort et m\u00eame temp\u00e9rature pour les deux dormeurs. Le choix naturel jusqu\u2019\u00e0 140 cm.' },
      dual: { t: 'Deux matelas s\u00e9par\u00e9s', d: 'Deux poches ind\u00e9pendantes avec diviseur : chacun r\u00e8gle SA fermet\u00e9 et SA temp\u00e9rature, sans transmettre ses mouvements. D\u00e8s 140 cm.' },
      kombi: { t: 'Deux matelas combin\u00e9s', d: 'Deux poches jumel\u00e9es sous un m\u00eame dessus : deux r\u00e9glages de confort, aucune s\u00e9paration sensible au centre. D\u00e8s 150 cm.' }
    };
    var STAB_TIP = {
      F0: { t: 'F0 \u2014 la vague historique', d: 'Ondulation libre, stabilisation en ~25 s : la sensation d\u2019apesanteur des lits \u00e0 eau d\u2019origine. Pour les puristes.' },
      F2: { t: 'F2 \u2014 ondulation douce', d: 'L\u2019eau se stabilise en ~6 s : le mouvement reste pr\u00e9sent mais apais\u00e9. Belle porte d\u2019entr\u00e9e dans le lit \u00e0 eau.' },
      F3: { t: 'F3 \u2014 \u00e9quilibr\u00e9', d: 'Stabilisation en ~3 s : l\u2019équilibre entre mouvement et soutien. Compatible support lombaire.' },
      F4: { t: 'F4 \u2014 soutien affirm\u00e9', d: 'Stabilisation en ~1 s : on sent \u00e0 peine l\u2019eau bouger. Le choix le plus fr\u00e9quent.' },
      F5: { t: 'F5 \u2014 ferme', d: 'Stabilisation en ~\u00bd s : quasi immobile, soutien marqu\u00e9.' },
      F6: { t: 'F6 \u2014 immobile', d: 'Stabilisation imm\u00e9diate : aucune ondulation perceptible.' },
      F7: { t: 'F7 \u2014 tr\u00e8s ferme', d: 'Enfoncement lent, accueil tonique proche d\u2019un matelas classique haut de gamme.' },
      F8: { t: 'F8 \u2014 le plus ferme', d: 'Enfoncement tr\u00e8s lent : le maximum de fermet\u00e9 Akva. (Sans support lombaire.)' },
      'Ergo Medium': { t: 'Ergo Medium', d: 'Mousse ergonomique zon\u00e9e, accueil medium : soutien renforc\u00e9 au bassin et aux \u00e9paules. Id\u00e9al si vous dormez sur le c\u00f4t\u00e9.' },
      'Ergo Ferme': { t: 'Ergo Ferme', d: 'Mousse ergonomique zon\u00e9e, accueil ferme : le soutien zon\u00e9 avec un maintien plus tonique.' },
      'F1-Ergo': { t: 'F1-Ergo', d: 'Mousse ergonomique + fibres, degr\u00e9 moyen : le soutien zon\u00e9 avec un peu de vague.' },
      'F3-Ergo': { t: 'F3-Ergo', d: 'Mousse ergonomique + fibres, degr\u00e9 fort : zon\u00e9 et tr\u00e8s stable.' }
    };
    var TETE_TIP = {
      'tete-hugo': 'Panneau placage bois quasi vertical, pleine largeur : l\u2019\u00e9pure scandinave.',
      'tete-plateau': 'Panneaux verticaux cousus en simili, coins carr\u00e9s.',
      'tete-olympus': 'Panneau tissu fin et discret, m\u00eame largeur que le lit.',
      'tete-k2': 'Cuir/simili aux coins tr\u00e8s arrondis, double surpiq\u00fbre contrastante et boutons.',
      'tete-mt-thomas': 'Grand panneau d\u00e9bordant, boutonn\u00e9 en grille r\u00e9guli\u00e8re.',
      'tete-anton': 'Panneau flottant sobre, coins carr\u00e9s.',
      'tete-oskar': 'Panneau flottant soulign\u00e9 d\u2019un passepoil au contour.',
      'tete-mt-ventoux': 'Panneau bois inclin\u00e9 + coussins cuir suspendus \u00e0 cheval sur le bord : le confort de lecture.',
      'tete-mt-ventoux-comfort': 'La version enti\u00e8rement tapiss\u00e9e \u00e0 segments verticaux.'
    };
    var TOPT_TIP = {
      'Surpiq\u00fbres': 'Un surpiq\u00fbre contrastant souligne le contour de la t\u00eate. Incompatible avec les boutons : c\u2019est l\u2019un ou l\u2019autre.',
      'Hauteur sp\u00e9ciale': 'Fait fabriquer la t\u00eate \u00e0 une hauteur diff\u00e9rente de la standard \u2014 utile sous une fen\u00eatre ou pour s\u2019aligner \u00e0 un lambris.',
      'T\u00eate \u00e9tendue (+44 cm)': 'La t\u00eate d\u00e9passe de 22 cm de chaque c\u00f4t\u00e9 du lit : effet mur d\u2019adossement, tr\u00e8s graphique.',
      'Coussins (la paire)': 'Deux coussins assortis, suspendus \u00e0 la t\u00eate : le confort de lecture. Vendus par paire.'
    };
    var OPT_TIP = {
      surpiq: { t: 'Surpiq\u00fbres sur cadre', d: 'Une couture apparente souligne les ar\u00eates du cadre tissu : le d\u00e9tail couture qui change la lecture du lit.' },
      pieds: { t: 'Pieds bois massif', d: 'Remplace les pieds standard par du h\u00eatre teint\u00e9 ou du ch\u00eane massif : le lit para\u00eet pos\u00e9, on voit le sol dessous.' },
      facades: { t: 'Fa\u00e7ades rembourr\u00e9es', d: 'Les fa\u00e7ades des tiroirs sont capitonn\u00e9es dans le tissu du lit au lieu du d\u00e9cor : le socle dispara\u00eet visuellement dans le cadre.' },
      vegalampes: { t: 'Lampes int\u00e9gr\u00e9es (Vega)', d: 'Deux liseuses mont\u00e9es sur bras chrom\u00e9s directement dans la t\u00eate Vega : plus besoin de lampes de chevet. Elles apparaissent sur la maquette d\u00e8s que vous cochez.' },
      samestab: { t: 'M\u00eame confort des deux c\u00f4t\u00e9s', d: 'Coch\u00e9 : un seul r\u00e9glage pour tout le lit. D\u00e9coch\u00e9 : chaque c\u00f4t\u00e9 re\u00e7oit sa propre stabilisation (le prix suit la moyenne des deux).' },
      pouf: { t: 'Pouf Vega', d: 'Le pouf assorti au lit, sur ch\u00e2ssis chrom\u00e9 \u2014 il appara\u00eet au pied du lit sur la maquette d\u00e8s que vous en choisissez un.' }
    };
    var STATIC_TIP = {
      'fam-fibres': { t: 'Stabilisation par fibres', d: 'F0 (tr\u00e8s ondulant) \u00e0 F8 (quasi ferme) : des couches de fibres freinent le mouvement de l\u2019eau. Survolez chaque degr\u00e9 pour le comprendre.' },
      'fam-ergo': { t: 'Ergo / F-Ergo', d: 'Stabilisations zon\u00e9es : soutien renforc\u00e9 au bassin et aux \u00e9paules. Id\u00e9al pour les dormeurs sur le c\u00f4t\u00e9.' },
      dimspec: { t: 'Dimension sur mesure', d: 'Toute dimension jusqu\u2019\u00e0 240 \u00d7 240 cm : prix de la dimension standard sup\u00e9rieure + suppl\u00e9ment affich\u00e9 avant validation.' },
      mattype: { t: 'Standard ou allong\u00e9', d: 'Le matelas allong\u00e9 prolonge le couchage sous la t\u00eate de lit \u2014 disponible uniquement avec une t\u00eate.' },
      revetement: { t: 'Rev\u00eatement', d: 'La housse du matelas (Boogie, Flamenco, Swing\u2026) \u2014 incluse, au choix.' },
      mousse: { t: 'Mousse du cadre', d: 'Standard : bord accueillant. Ferme : bord plus porteur, assise facilit\u00e9e.' },
      boxkit: { t: 'Boxkit', d: 'Le lit SANS la partie eau : cadre, socle et plaques de support, pour installer votre propre matelas.' },
      'ded-liner': { t: 'Inliner / Outliner', d: 'Si vous n\u2019avez pas besoin du liner de s\u00e9curit\u00e9 : \u2212160 \u20ac, d\u00e9j\u00e0 d\u00e9duits du prix affich\u00e9.' },
      'ded-dessus': { t: 'Dessus non divisible', d: 'Dessus d\u2019une seule pi\u00e8ce au lieu du divisible : \u221275 \u20ac, d\u00e9j\u00e0 d\u00e9duits.' }
    };
    var LINE_TIP = {
      softside: { t: 'Softside', d: 'La ligne classique : c\u00f4t\u00e9s en mousse profil\u00e9e qui accueillent en douceur quand on s\u2019assoit au bord. Mousse standard ou ferme au choix, et les trois syst\u00e8mes possibles (un matelas, deux s\u00e9par\u00e9s, deux combin\u00e9s).' },
      'softside-q': { t: 'Softside Q', d: 'C\u00f4t\u00e9s en COUPE DROITE, plus architectural, mousse ferme d\u2019office. Un matelas ou deux s\u00e9par\u00e9s seulement (pas de combin\u00e9s), et le deux-matelas commence \u00e0 150 cm.' },
      hardside: { t: 'Hardside', d: 'La poche d\u2019eau remplit tout le cadre : la sensation la plus enveloppante, dans un lit enti\u00e8rement tapiss\u00e9 jusqu\u2019au sol.' }
    };
    var REVET_TIP = {
      'Boogie': 'Maille souple et respirante, l\u2019entr\u00e9e de gamme Akva : douce, l\u00e9g\u00e8re, lavable \u00e0 60\u00b0.',
      'Flamenco': 'Tissu plus dense et matelass\u00e9 : accueil plus moelleux et meilleure r\u00e9gulation que Boogie.',
      'Swing (Tencel)': 'Tencel (fibre de bois) : fra\u00eecheur et \u00e9vacuation de l\u2019humidit\u00e9 sup\u00e9rieures \u2014 pour ceux qui ont chaud la nuit.',
      'Swing+ (Tencel)': 'Le Tencel avec une couche de confort suppl\u00e9mentaire : m\u00eame fra\u00eecheur, accueil plus douillet.',
      'Salsa': 'Le plus \u00e9pais et le plus enveloppant de la gamme : matelassage g\u00e9n\u00e9reux, effet cocon.'
    };
    function socleTipOf(t) {
      if (!t) return { t: 'Socle D\u00e9cor (inclus)', d: 'Panneau d\u00e9cor r\u00e9sistant, teinte au choix. Aucun suppl\u00e9ment.' };
      if (t.indexOf('Tiroirs') === 0) {
        var what = /big/i.test(t) ? 'tiroirs PLEINE HAUTEUR (toute la hauteur du socle)' : /4/.test(t) ? 'deux tiroirs de chaque c\u00f4t\u00e9' : 'deux grands tiroirs sur un c\u00f4t\u00e9';
        var mat = /placage/i.test(t) ? 'fa\u00e7ades en vrai placage bois' : 'fa\u00e7ades d\u00e9cor';
        return { t: t, d: 'Du rangement int\u00e9gr\u00e9 au lit : ' + what + ', ' + mat + '. Fa\u00e7ades rembourr\u00e9es possibles.' };
      }
      if (/miroir/i.test(t)) return { t: 'Socle miroir', d: 'Fa\u00e7ades miroir : le lit semble flotter. Jusqu\u2019\u00e0 37,5 cm de hauteur.' };
      if (/Benti/i.test(t)) return { t: 'Benti (aluminium)', d: 'Corni\u00e8res aluminium bross\u00e9, esprit contemporain, hauteur 25 cm.' };
      return { t: 'Socle placage', d: 'Vrai placage bois assorti \u00e0 votre chambre. Le montant affich\u00e9 est la diff\u00e9rence exacte avec le socle inclus.' };
    }
    function netOf(mut) { return currentVariant() ? tryNet(mut) : null; }
    function tipData(raw) {
      var p = raw.split(':'), kind = p[0], a = p.slice(1).join(':');
      var out = null, price = null;
      if (kind === 'sys') { out = SYS_TIP[a]; price = netOf({ system: a }); }
      else if (kind === 'stab') { var side = a.split(':')[0], key = a.split(':').slice(1).join(':'); out = STAB_TIP[key] || { t: key, d: '' }; price = netOf(side === 'L' ? { stabL: key } : { stabR: key }); if (price == null) price = tryNet(side === 'L' ? { stabL: key } : { stabR: key }); }
      else if (kind === 'width') { out = { t: 'Largeur ' + a + ' cm', d: 'Les largeurs partagent leur prix par bande : 90/100/120 \u00b7 140/150/160 \u00b7 180/200. D\u00e8s 140 cm, les deux matelas s\u00e9par\u00e9s deviennent possibles (combin\u00e9s d\u00e8s 150).' }; price = netOf({ width: a }); if (price == null) price = tryNet({ width: a, stabL: S.stabL || 'F3', sameStab: true }); }
            else if (kind === 'socleh') { var hv = parseFloat(a);
        out = { t: 'Socle ' + hLabel(hv), d: 'Couchage \u00e0 ~' + hLabel(hv + LAYING) + '. ' +
          (HEIGHTS && HEIGHTS.length === 1 ? 'C\u2019est la hauteur de ce mod\u00e8le : elle ne se choisit pas.' :
           hv <= 27 ? 'La hauteur basse : lignes plus \u00e9pur\u00e9es, esprit podium.' :
           hv <= 31 ? 'Un cran plus haut : on se rel\u00e8ve plus facilement.' :
           'Hauteur haute : lever tr\u00e8s facile, plus de place sous le lit.') };
        price = netOf({ socleCm: hv, socleH: bracketOf(hv) }); }
      else if (kind === 'socletype') { out = socleTipOf(a); price = netOf({ socleType: a || null }); }
      else if (kind === 'tete') { var lb = ''; (V.tete.catalog || []).forEach(function (x) { if (x.handle === a) lb = x.label; });
        out = { t: lb || 'Sans t\u00eate de lit', d: a ? (TETE_TIP[a] || '') : 'Le lit est livr\u00e9 sans t\u00eate : la maquette en montre une pour le rendu, elle n\u2019est pas factur\u00e9e.', photo: tetePhoto(a) };
        price = netOf({ tete: a || null }); }
      else if (kind === 'teteinc') { var hh = 'tete-' + a.toLowerCase(); out = { t: a + ' (incluse)', d: (TETE_TIP[hh] || '') + ' Incluse avec ce mod\u00e8le.' }; }
      else if (kind === 'ls') { out = { t: 'Support lombaire', d: 'Renfort int\u00e9gr\u00e9 sous les reins \u2014 existe de F3 \u00e0 F7. Recommand\u00e9 en cas de sensibilit\u00e9 lombaire.' }; var kk = a === 'L' ? 'lsL' : 'lsR'; var mm = {}; mm[kk] = !S[kk]; price = netOf(mm); }
      else if (kind === 'line') { out = LINE_TIP[a] || { t: a, d: '' }; price = netOf({ line: a }); }
      else if (kind === 'length') { out = { t: 'Longueur ' + a + ' cm', d: 'La longueur ne change pas la bande de prix : elle suit la largeur. Comptez ~15 cm de plus que votre taille pour dormir \u00e0 l\u2019aise.' }; price = netOf({ length: a }); }
      else if (kind === 'revet') { out = { t: a, d: REVET_TIP[a] || 'Rev\u00eatement du matelas, inclus au choix.' }; }
      else if (kind === 'sw') { var act = a.split(':')[0], nom = a.split(':').slice(1).join(':');
        out = { t: nom, d: (act === 'cadre' ? 'Couleur du cadre' : act === 'soclecol' ? 'Couleur du socle' : 'Couleur de la t\u00eate de lit') + ' \u2014 elle s\u2019applique EN DIRECT sur la maquette 3D \u00e0 gauche. Cliquez pour voir le rendu.' }; }
      else if (kind === 'topt') { out = { t: a, d: TOPT_TIP[a] || 'Option de la t\u00eate de lit.' }; }
      else if (kind === 'opt') { out = OPT_TIP[a] || null; }
      else out = STATIC_TIP[kind] || STATIC_TIP[raw] || null;
      if (!out) return null;
      return { t: out.t, d: out.d, page: PAGE_OF[kind], price: price, photo: out.photo || null };
    }
    var tipEl = document.createElement('div');
    tipEl.className = 'cf2__tip';
    document.body.appendChild(tipEl);
    var tipHideT = null, tipShowT = null, tipCur = null;
    function tipHide() {
      clearTimeout(tipShowT); clearTimeout(tipHideT); tipCur = null;
      tipHideT = setTimeout(function () { tipEl.classList.remove('is-on'); }, 60);
    }
    function tipShow(t) {
      var g = tipData(t.getAttribute('data-tip')); if (!g) return;
      clearTimeout(tipHideT);
      /* meme raison que `deltaTxt` : `g.price` vient de `tryNet` */
      var cur = currentVariant() ? totals(true).net : null;
      var priceRow = '';
      if (g.price != null) {
        var delta = cur != null ? g.price - cur : null;
        priceRow = '<div class="cf2__tipp"><span>' + (cur == null ? '\u00e0 partir de' : 'Avec ce choix') + '</span><b>' + euro(g.price) + '</b>' +
          (delta !== null && delta !== 0 ? '<i>' + (delta > 0 ? '+ ' : '\u2212 ') + euro(Math.abs(delta)) + '</i>' : (delta === 0 ? '<i>votre s\u00e9lection</i>' : '')) + '</div>';
      }
      tipEl.innerHTML = (g.photo ? '<img class="cf2__tipimg" src="' + g.photo + '" alt="">' : '') +
        '<b>' + g.t + '</b><p>' + g.d + '</p>' + priceRow +
        (g.page ? '<a href="/pages/' + g.page + '" target="_blank" rel="noopener">Guide d\u00e9taill\u00e9 \u2197</a>' : '');
      var r = t.getBoundingClientRect();
      tipEl.classList.add('is-on');
      tipEl.style.left = Math.max(10, Math.min(window.innerWidth - 352, r.left + r.width / 2 - 170)) + 'px';
      var top = r.top - tipEl.offsetHeight - 12;
      if (top < 8) top = r.bottom + 12;
      tipEl.style.top = top + 'px';
    }
    /* la carte ne s'ouvre qu'apres une INTENTION (survol maintenu) et dispara\u00eet des qu'on part :
       elle ne doit jamais g\u00eaner la navigation dans le configurateur. */
    mount.addEventListener('mouseover', function (e) {
      var t = e.target.closest('[data-tip]');
      if (!t) { tipHide(); return; }
      if (t === tipCur) { clearTimeout(tipHideT); return; }
      clearTimeout(tipShowT); clearTimeout(tipHideT);
      tipCur = t;
      var wasOn = tipEl.classList.contains('is-on');
      tipShowT = setTimeout(function () { if (tipCur === t) tipShow(t); }, wasOn ? 90 : 420);
    });
    mount.addEventListener('mouseout', function (e) {
      var to = e.relatedTarget;
      if (to && (to.closest('[data-tip]') || to.closest('.cf2__tip'))) return;
      tipHide();
    });
    mount.addEventListener('click', function () { tipHide(); tipEl.classList.remove('is-on'); }, true);
    mount.addEventListener('mouseleave', tipHide);
    tipEl.addEventListener('mouseenter', function () { clearTimeout(tipHideT); });
    tipEl.addEventListener('mouseleave', tipHide);
    window.addEventListener('scroll', function () { tipEl.classList.remove('is-on'); }, { passive: true });

    /* 🛑 L'INSTALLATION RETENUE, ET SON IDENTIFIANT DE VARIANTE.
       `relais()` ne recopie que `act/val/name/url` : les kilometres et l'adresse
       y mouraient. On ecoute donc un evenement DEDIE, qui porte ce que le panier
       doit recevoir. Mesure du 20/09 avant correction : 70 EUR affiches,
       0 EUR encaisses, aucune ligne sur la commande. */
    var INSTALL = null;
    document.addEventListener('lae:install', function (e) {
      var d = (e && e.detail) || {};
      var neuf = d.id ? d : null;
      /* 🛑 LA GARDE VA ICI, A LA SOURCE — pas dans un autre fichier.
         `basculer(false)` (litaeau-conf-js) dispatche LUI-MEME
         `lae:install {id:null}` quand le client revient sur « je m'en occupe ».
         Sans cette sortie, la repeinture ci-dessous relancerait une passe
         complete a chaque aller-retour, et `basculer(true)` volerait le focus
         au champ d'adresse en cours de saisie. On compare l'ETAT, pas
         l'evenement : deux evenements identiques ne font rien. */
      var avant = INSTALL ? (INSTALL.id + '|' + INSTALL.prix) : '';
      var apres = neuf ? (neuf.id + '|' + neuf.prix) : '';
      if (avant === apres) return;
      INSTALL = neuf;
      /* 🛑 ET ON REDEMANDE L'AFFICHAGE. Mesure du 20/09 : `totals()` rendait
         deja 3 390 EUR pendant que le bandeau affichait 2 970 — le calcul etait
         juste, personne ne le peignait. L'ecouteur n'appelait rien.
         `refresh()` peint le bandeau, le sous-titre et le bouton, ET emet
         `lae:config` qui nourrit `majCompris()` ; `build()` re-rend le panneau,
         dont `renderRecap()`. LES DEUX SONT NECESSAIRES : sans `build()`, le
         bandeau dirait 3 390 et le recapitulatif 2 970, sur le meme ecran.
         ⚠️ `build()` reecrit `mount.innerHTML` — le champ d'adresse vit HORS de
            `mount`, la frappe est donc a l'abri ; seules les infobulles
            ouvertes partent, ce qui est sans consequence ici. */
      try { build(); refresh(); } catch (x) { }
    });

    /* ── interactions ── */
    mount.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]'); if (!b || b.disabled) return;
      var a = b.getAttribute('data-act'), val = b.getAttribute('data-val');
      /* 🛑 CE QUE L'UTILISATRICE A TOUCHE, ET CE QU'UN DEFAUT A REMPLI.
         La hauteur de socle a une valeur par defaut (25 cm) : sans cette trace,
         l'etape « socle » se cocherait avant meme qu'on l'ait ouverte, et une
         barre de progression qui avance toute seule ne dit plus rien. */
      /* ⚠️ UN DEFAUT REJOUE N'EST PAS UN CHOIX. `relais()` pose les valeurs par
         defaut en fabriquant un vrai bouton et en le cliquant — c'est voulu, et
         bien vu : le moteur met alors a jour d'un coup la teinte, l'URL du
         nuancier, le type de socle et la maquette 3D, la ou un etat ecrit a la
         main finirait par contredire le sien. Mais ce clic-la n'est pas celui
         d'une personne. Il porte donc `data-defaut`, et seul un clic SANS cette
         marque temoigne d'une decision. */
      var parDefaut = b.hasAttribute('data-defaut');
      if (!parDefaut && (a === 'socleh' || a === 'soclecol' || a === 'soclefin')) S._socleVu = true;
      /* le type de socle a son propre temoin : il est decide dans l'etape 05, pas
         dans la 04, et une etape ne se coche que par un geste qui la concerne */
      if (!parDefaut && a === 'socletype') S._socleTypeVu = true;
      if (!parDefaut && (a === 'cadre' || a === 'revet')) S._finVu = true;
      if (a === 'show3d') { document.dispatchEvent(new CustomEvent('lae:show3d')); return; }
      if (a === 'open') { S.open = (S.open === +val ? -1 : +val); build(); refresh(); return; }
      if (a === 'next') { S.open = Math.min(S.open + 1, 7); build(); refresh(); return; }
      if (a === 'line') { S.line = val; if (S.system && !sysAllowed(S.system).ok) { S.system = null; S.width = S.length = null; } if (S.system === 'kombi' && line().systems.indexOf('kombi') < 0) S.system = null; }
      else if (a === 'system') {
        S.system = val; S.width = S.length = null; S.dimspec = null;
        if (!twoSides()) { S.stabR = null; S.lsR = false; S.sameStab = true; }
        /* 🛑 NE PAS DECIDER A LA PLACE DU CLIENT. En passant a deux poches,
           `sameStab` restait a `true` (sa valeur de depart, juste pour le
           matelas unique) : on venait de lui vendre deux reglages independants
           et on cochait aussitot « le meme des deux cotes ». Demande du 06/09 :
           « quand on choisit matelas double ne pas partir du postulat que c'est
           direct coche ». Deux poches = deux choix ouverts. */
        else S.sameStab = false;
      }
      else if (a === 'socleh') {
        S.socleCm = parseFloat(val); S.socleH = bracketOf(S.socleCm);
        /* 🛑 NE JETER QUE CE QUI EST VRAIMENT DEVENU IMPOSSIBLE.
           Sur le Lyra (Hardside), la hauteur de socle est une CLE de table de
           prix : elle change les couples largeur × longueur disponibles
           (`rowHeightOK`). Le code effaçait donc les deux, sans regarder si le
           couple choisi restait valable. Or la page presente la hauteur de socle
           en etape 04, APRES les dimensions en etape 02 : mesure du 07/09 sur
           /pages/configurer-lyra — apres couchage + 90×200 + F0 le bouton disait
           deja « Ajouter au panier », puis le clic sur « 25 cm » renvoyait `dim`
           a « attente » et le bouton redevenait « Choisissez la dimension ».
           Le parcours normal de la page ne pouvait donc JAMAIS aboutir.
           On revalide au lieu d'effacer : la largeur ne tombe que si elle sort
           des rangees de la nouvelle hauteur, et la longueur que si elle sort
           des longueurs de cette largeur. Quand le couple reste possible, il
           reste choisi — et l'etape reste « fait ». */
        if (isLyra && S.width) {
          var wS = String(S.width);
          if (widthsAll().indexOf(wS) < 0 || !widthInfo(wS).ok) { S.width = S.length = null; }
          else if (S.length && lengthsFor(wS).indexOf(String(S.length)) < 0) { S.length = null; }
        }
      }
      else if (a === 'width') {
        S.width = val; S.dimspec = null;
        var LL = lengthsFor(val);
        S.length = LL.length === 1 ? LL[0] : (LL.indexOf(S.length) >= 0 ? S.length : null);
      }
      else if (a === 'length') { S.length = val; S.dimspec = null; }
      else if (a === 'dimspec-toggle') { S._dimspecOpen = !S._dimspecOpen; }
      else if (a === 'dimspec-apply') {
        var w = parseInt(mount.querySelector('[data-ds="w"]').value, 10), l = parseInt(mount.querySelector('[data-ds="l"]').value, 10);
        var errBox = mount.querySelector('[data-ds-err]');
        var res = validateDimspec(w, l);
        if (res.err) { errBox.hidden = false; errBox.textContent = res.err; return; }
        S.dimspec = res; S.width = null; S.length = null; S._dimspecOpen = false;      }
      else if (a === 'dimspec-clear') { S.dimspec = null; }
      else if (a === 'socle-sm-toggle') { S._socleSmOpen = !S._socleSmOpen; }
      else if (a === 'socle-sm-apply') {
        var smIn = mount.querySelector('[data-ssm]');
        var smErr = mount.querySelector('[data-ssm-err]');
        var res = validateSocleSm(smNb(smIn ? smIn.value : ''));
        if (res.err) { if (smErr) { smErr.hidden = false; smErr.textContent = res.err; } return; }
        S.socleSurMesure = true; S.socleSmCm = res.cm; S._socleSmOpen = false;
        /* 🛑 « +75 sur la dimension SUPERIEURE ». Poser la cote ne suffit pas :
           il faut aussi basculer la TRANCHE DE PRIX, sinon on facture la
           tranche que le client avait choisie. Sur le Lyra — seul lit a
           proposer les deux, 340 € d'ecart — demander 46 cm depuis 25/30
           facturait 340 € de moins que le tarif.
           ⚠️ On ne bascule QUE si ce lit offre vraiment la tranche : la plupart
              n'en ont qu'une, et l'y forcer sortirait de sa grille de prix. */
        var brk = bracketOf(res.cm);
        var dispo = (HEIGHTS || []).filter(function (h) { return bracketOf(h) === brk; });
        if (dispo.length && S.socleH !== brk) {
          S.socleH = brk;
          S.socleCm = dispo[dispo.length - 1];
        }
        S._socleSmBrk = dispo.length ? brk : S.socleH;
      }
      else if (a === 'socle-sm-clear') {
        S.socleSurMesure = false; S.socleSmCm = null; S._socleSmBrk = null;
        /* ⚠️ On ne restaure PAS la tranche d'avant : le client voit la
           hauteur standard selectionnee, elle est coherente, et deviner
           son choix anterieur serait pire que de le laisser choisir. */
      }
      else if (a === 'fam-L') { S._famL = val; if (S.stabL && famOf(S.stabL) !== val) S.stabL = null; }
      else if (a === 'fam-R') { S._famR = val; if (S.stabR && famOf(S.stabR) !== val) S.stabR = null; }
      else if (a === 'stab-L') { S.stabL = val; if (!stabByKey[val].ls) S.lsL = false; if (S.sameStab) { if (!stabByKey[val].ls) S.lsR = false; } }
      else if (a === 'stab-R') { S.stabR = val; if (!stabByKey[val].ls) S.lsR = false; }
      else if (a === 'samestab') { S.sameStab = !S.sameStab; if (S.sameStab) { S.stabR = null; } }
      else if (a === 'ls-L') { S.lsL = !S.lsL; }
      else if (a === 'ls-R') { S.lsR = !S.lsR; }
      else if (a === 'cadre') { S.cadre = b.getAttribute('data-name'); S.cadreUrl = b.getAttribute('data-url'); }
      else if (a === 'soclecol') { S.socleCol = b.getAttribute('data-name'); S.socleColUrl = b.getAttribute('data-url'); }
      else if (a === 'mousse') { S.mousse = val; }
      else if (a === 'revet') { S.revetement = val; }
      else if (a === 'mattype') { S.matType = val; }
      else if (a === 'socletype') { S.socleType = val || null; if (!val || val.indexOf('Tiroirs') < 0) S.facades = false; }
      else if (a === 'facades') { S.facades = !S.facades; }
      else if (a === 'tete') { S.tete = val || null; S._teteTouched = true; S.teteTier = null; S.teteOpt = {}; if (!val) S.matType = 'Standard'; }
      else if (a === 'tetetier') { S.teteTier = val; S.teteCol = null; S.teteColUrl = null; }
      else if (a === 'tetecol') { S.teteCol = b.getAttribute('data-name'); S.teteColUrl = b.getAttribute('data-url'); }
      else if (a === 'teteopt') { S.teteOpt[val] = !S.teteOpt[val]; }
      /* 🛑 CHOISIR SA TETE, C'EST TOUCHER L'ETAPE — QUEL QUE SOIT LE MODE.
         `S._teteTouched` n'etait pose que par l'acte `tete` (mode catalogue).
         En mode « incluse » (Carla : Anton / Oskar) et en mode Vega, le client
         choisissait bien sa tete, mais le temoin restait faux : l'etape restait
         « attente » POUR TOUJOURS dans le sommaire, alors que le bouton disait
         « Ajouter au panier ». Mesure du 07/09 sur /pages/configurer-carla :
         teteinc=Anton clique, etapes.tete = « attente ». */
      else if (a === 'teteinc') { S.teteInc = val; S._teteTouched = true; }
      else if (a === 'vegatete') { S.vega.tete = val || null; S._teteTouched = true; if (!val) S.matType = 'Standard'; }
      else if (a === 'vegacadre') { S.vega.cadre = val || null; }
      /* 🛑 UNE SEULE COMMANDE POUR LA FINITION, PAS DEUX AXES A COMPOSER.
         Elle pose ensemble la matiere ET sa teinte : le Decor est compris
         (Black ou White), le placage est un echange facture (p.32). Deux
         controles separes recreeraient la composition qui a deja fait
         repartir un client avec le mauvais socle. */
      else if (a === 'soclefin') {
        var _C = (cfg.socle && cfg.socle.colors) || [];
        var _sw = function (nm) {
          for (var i = 0; i < _C.length; i++) if (_C[i].name === nm) return _C[i];
          return null;
        };
        var _DEF = { noir: ['Black', null], blanc: ['White', null],
                     placage: ['Dark chestnut', 'Socle placage'] };
        var _d = _DEF[val];
        if (_d) {
          var _c = _sw(_d[0]);
          if (_c) { S.socleCol = _c.name; S.socleColUrl = _c.url; }
          S.socleType = _d[1];
          S.socleFin = val;
        }
      }
      else if (a === 'coulissement') { S.coulissement = val || null; }
      /* 🛑 L'INSTALLATION EST UNE DECISION, PAS UN DEFAUT SILENCIEUX. Elle etait posee
         `option` en dur : ne rien cliquer valait « je monte moi-meme », sans que le client
         l'ait jamais dit. Le moteur retient le geste ; l'etape attend qu'il tranche, dans un
         sens ou dans l'autre. La livraison reste offerte et le montage soi-meme reste
         gratuit — on ne force pas un achat, on force une REPONSE. */
      else if (a === 'install') { S._installVu = true; S.installOn = (val === 'on'); }
      else if (a === 'vegalampes') { S.vega.lampes = !S.vega.lampes; }
      else if (a === 'vegapouf') { S.vega.pouf = val || null; }
      else if (a === 'pieds') { S.pieds = !S.pieds; }
      else if (a === 'surpiq') { S.surpiq = !S.surpiq; }
      else if (a === 'ded') { S.ded[val] = !S.ded[val]; }
      else if (a === 'boxkit') {
        S.boxkit = !S.boxkit;
        if (S.boxkit) { S.stabL = S.stabR = null; S.lsL = S.lsR = false; S.system = S.system || 'uno'; S.ded = { liner: false, dessus: false }; }
      }
      build(); refresh();
    });

    /* ── relais des choix faits AILLEURS dans la page (les chapitres du récit) ──
       On ne recopie PAS l'aiguillage ci-dessus : on injecte dans le panneau un bouton
       portant les mêmes attributs, et on le clique. Le récit et le panneau empruntent
       donc exactement le même chemin — un aiguillage recopié aurait divergué dès le
       premier ajout d'option, et le prix du récit aurait fini par mentir.
       Le bouton disparaît de lui-même : le handler termine par build(), qui réécrit
       mount.innerHTML. Le retrait explicite ne couvre que les retours anticipés. */
    function relais(d) {
      if (!d || !d.act) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-act', d.act);
      if (d.val !== undefined && d.val !== null) b.setAttribute('data-val', d.val);
      if (d.name) b.setAttribute('data-name', d.name);
      if (d.url) b.setAttribute('data-url', d.url);
      /* la marque qui distingue un defaut pose par la page d'un choix fait par
         une personne — lue par l'aiguillage, jamais rendue a l'ecran */
      if (d.defaut) b.setAttribute('data-defaut', '1');
      b.style.cssText = 'position:absolute;width:0;height:0;padding:0;border:0;opacity:0';
      mount.appendChild(b);
      try { b.click(); } finally { if (b.parentNode) b.parentNode.removeChild(b); }
    }
    document.addEventListener('lae:choix', function (e) { relais(e.detail); });

    /* API lue par litaeau-recit.js. `pret` sert de témoin : le récit n'affiche ses
       contrôles relais que si le moteur a vraiment démarré sur cette page. */
    window.__LAE_CFG = {
      pret: true,
      modele: (cfg && cfg.model) || '',
      choisir: function (act, val, extra) {
        var d = { act: act, val: val };
        if (extra) { if (extra.name) d.name = extra.name; if (extra.url) d.url = extra.url; }
        relais(d);
      },
      etat: function () { return window.__LAE_DERNIER_CONFIG || null; },
      /* 🛑 LES TROIS FONCTIONS DE PRIX QUE LA PAGE APPELLE — ET QUI MANQUAIENT.
         `_fiche_corps.liquid` chiffre CHAQUE vignette avec `prixSi(mutation)`,
         affiche le total avec `prixActuel()` et le point de depart avec
         `prixPlancher()`. Aucune des trois n'etait exposee : la console rendait
         « window.__LAE_CFG.prixSi is not a function », `chiffrer()` sortait a sa
         premiere ligne (`if (!API || !API.prixSi) return;`) et TOUTES les
         etiquettes restaient vides. Mesure du 07/09 : 65 emplacements de prix,
         33 remplis, zero sur les dimensions et sur la fermete — exactement ce
         qui etait signale. Les trois calculs existaient deja dans le moteur
         (`tryNet`, `totals`, `PLANCHER`) : il ne manquait que la porte.
         🛑 En CENTIMES, comme le reste du moteur : la page divise par 100. */
      /* 🛑 LES DEUX FONCTIONS DU SUR-MESURE, QUE LE PILOTE APPELAIT DANS LE VIDE.
         `litaeau-conf-js.liquid` appelle `API.surMesureTarif()` pour remplir le montant du
         supplement, et `API.surMesure(w, l)` pour le bouton « Calculer ». Aucune des deux
         n'existait : les deux appels sont proteges par un `if (!API.surMesure) return;`,
         donc ils echouaient sans bruit. Mesure au navigateur le 14/09 : le span restait
         vide et la phrase se terminait sur « plus un supplement . ».
         🛑 C'est le DEUXIEME contrat muet du meme configurateur — `prixSi`, `prixActuel` et
         `prixPlancher` manquaient deja, laissant 65 etiquettes de prix vides. */
      surMesure: function (w, l) {
        try { return validateDimspec(w, l); } catch (e) { return null; }
      },
      surMesureTarif: function () {
        try {
          var d = V && V.dimspec;
          if (!d || !d.t1) return null;
          /* ATTENTION SANS LE SYMBOLE : le pilote ecrit lui-meme le EUR, renvoyer euro()
             ici rendait « 573 EUR EUR ». Mesure au navigateur le 14/09. */
          var nb = function (x) { return _fr0(x || 0); };   /* meme formateur memoise — cf. _fr0 */
          return { t1: nb(d.t1.price), t1l: d.t1.label || '',
                   t2: d.t2 ? nb(d.t2.price) : '', t2l: (d.t2 && d.t2.label) || '',
                   t2c: (d.t2 && d.t2.cond) || '' };
        } catch (e) { return null; }
      },
      prixSi: function (mut) {
        try { return prixHypothese(mut); } catch (e) { return null; }
      },
      __inutilise: function (mut) {
        try {
          var direct = tryNet(mut || {});
          if (direct !== null) return direct;
          /* 🛑 CHIFFRER UNE HYPOTHESE PLUTOT QUE DE SE TAIRE. `tryNet` passe par
             `currentVariant()`, qui exige une largeur, une longueur et une
             stabilisation : au chargement il n'y en a aucune, donc il rendait
             null et TOUTES les vignettes restaient muettes — y compris celles
             des dimensions et de la fermete, celles qu'on regarde en premier.
             On complete donc l'etat avec la configuration la plus simple (le
             plus petit format, en uno, premier palier) : la vignette annonce un
             prix reel, celui de sa combinaison la moins chere. Des qu'un vrai
             choix existe, la premiere branche reprend la main. */
          var f0 = null;
          V.stabs.forEach(function (x) { if (!f0 && x.fam === 'fibres') f0 = x.key; });
          /* 🛑 ON ESSAIE CHAQUE BANDE, PAS SEULEMENT LA PREMIERE. « Deux matelas »
             n'existe pas sous 140 cm (le tarif le dit : « uno uniquement, pas de
             dual sous 140 »). En ne completant qu'avec la plus petite bande, la
             vignette « Deux matelas » restait muette — la seule des soixante-cinq.
             On descend les bandes jusqu'a celle qui sait servir la combinaison :
             la vignette annonce alors le prix de depart REEL de ce choix. */
          /* 🛑 LE LYRA N'A PAS DE BANDES DE LARGEUR. C'est un Hardside : sa cle
             `bands` porte les HAUTEURS DE SOCLE, et ses dimensions vivent dans
             `lyraRows` (26 couples fixes). En le completant avec `bands`, on lui
             posait « 25/30 » comme largeur : 10 etiquettes remplies sur 59, le
             reste muet. On lui donne donc ses vraies lignes. */
          var sources = (V.lyraRows || []).length
            ? V.lyraRows.map(function (r) {
                return { widths: r.widths || [], lengths: r.lengths || [], system: r.system };
              })
            : (V.bands || []);
          for (var i = 0; i < Math.max(1, sources.length); i++) {
            var b = sources[i] || {};
            var m2 = {};
            if (!S.system) m2.system = b.system || 'uno';
            if (!S.width && (b.widths || []).length) m2.width = b.widths[0];
            if (!S.length && (b.lengths || []).length) m2.length = b.lengths[0];
            if (!S.stabL && f0) m2.stabL = f0;
            Object.keys(mut || {}).forEach(function (k) { m2[k] = mut[k]; });
            var essai = tryNet(m2);
            if (essai !== null) return essai;
          }
          return null;
        } catch (e) { return null; }
      },
      prixActuel: function () {
        /* le prix EXACT de la configuration courante — null tant qu'elle n'est
           pas resolue, et c'est voulu : `chiffrer()` s'en sert pour savoir s'il
           doit afficher un montant absolu (« 2 970 € ») ou un ecart (« + 232 € »). */
        try { return currentVariant() ? totals().net : null; } catch (e) { return null; }
      },
      prixPlancher: function () { return PLANCHER; },
      ouvrir: function (n) {
        relais({ act: 'open', val: n });
        var el = root.querySelector('.cf2__step[data-step="' + n + '"]');
        if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };

    function validateDimspec(w, l) {
      if (!w || !l) return { err: 'Renseignez largeur et longueur.' };
      if (w > 240 || l > 240) return { err: 'Maximum 240 × 240 cm.' };
      if (w < 80 || l < 180) return { err: 'Dimensions minimales : 80 cm de large, 180 cm de long.' };
      var tier = (w > 200 || l > 240) ? 2 : (w > 200 ? 2 : 1);
      /* 2e tranche : entre 200x240 et 240x240 */
      tier = (w > 200) ? 2 : 1;
      if (tier === 2 && !twoSides()) return { err: 'Au-delà de 200 cm de large : uniquement en deux matelas, avec dessus divisible.' };
      /* base = dimension standard supérieure */
      var baseW = null, ws = ['120', '160', '200'];
      if (!isLyra) {
        var bl2 = bandsList();
        for (var i = 0; i < bl2.length; i++) {
          var maxw = Math.max.apply(null, bl2[i].widths.map(Number));
          if (w <= maxw) { baseW = bl2[i].widths[bl2[i].widths.length - 1]; break; }
        }
        if (!baseW) baseW = '200';
      }
      var sysOK = widthInfo(baseW); if (!sysOK.ok) return { err: sysOK.why };
      return { w: w, l: l, tier: tier, baseW: baseW };
    }

    /* ── panier ── */
    var addBtn = bar ? bar.querySelector('[data-cf-add]') : null;
    if (addBtn) addBtn.addEventListener('click', function () {
      if (!complete()) {
        /* incomplet : le bouton est un raccourci, pas un ajout au panier */
        var k = prochaineCle();
        if (k) document.dispatchEvent(new CustomEvent('lae:aller', { detail: { etape: k } }));
        return;
      }
      var v = currentVariant(); if (!v) return;
      var rs = resolvedStab();
      /* 🛑 LA DIMENSION D'ABORD. Decision de l'utilisatrice : c'est ce que le
         client a choisi et ce qu'il reconnait ; le couchage vient ensuite.
         L'ordre de ces cles EST l'ordre affiche au panier, et seules les trois
         premieres restent en clair — le reste se replie. La dimension ne doit
         jamais tomber dans le repli. */
      var props = {
        'Dimension': S.dimspec ? (S.dimspec.w + ' × ' + S.dimspec.l + ' cm (sur mesure)') : (S.width + ' × ' + S.length + ' cm'),
        'Couchage': sysDef(S.system).label + ' · ' + line().label
      };
      if (!S.boxkit) {
        if (twoSides() && !S.sameStab) { props['Stabilisation côté gauche'] = S.stabL; props['Stabilisation côté droit'] = S.stabR; props['Degré résultant'] = rs.resKey; }
        else props['Stabilisation'] = S.stabL;
        if (twoSides() && (S.lsL || S.lsR)) props['Support lombaire'] = [S.lsL ? 'côté gauche' : null, S.lsR ? 'côté droit' : null].filter(Boolean).join(' + ');
      }
      /* 🛑 On n'ecrit la propriete QUE si elle a un sens : sur un socle sans
         tiroirs elle n'existe pas, et sur un Big Box le tarif ne laisse pas
         le choix — l'ecrire ferait croire a une option qu'Akva ne sert pas. */
      var _st = String(S.socleType || '');
      if (_st.indexOf('box') >= 0 && _st.indexOf('big box') < 0) {
        props['Coulissement des tiroirs'] = S.coulissement || 'glissi\u00e8res';
      } else if (_st.indexOf('big box') >= 0) {
        props['Coulissement des tiroirs'] = 'roulettes';
      }
      if (S.cadre) props['Cadre'] = S.cadre;
      if (S.mousse) props['Mousse'] = S.mousse;
      if (S.socleCol) props['Coloris socle'] = S.socleCol;
      props['Hauteur socle'] = S.socleCm ? (hLabel(S.socleCm) + ' \u00b7 couchage ~' + hLabel(S.socleCm + LAYING)) : S.socleH;
      /* 🛑 La cote sur mesure doit atteindre l'atelier. Sans cette ligne,
         la commande facture 75 € et ne dit pas quelle hauteur fabriquer. */
      if (S.socleSurMesure && S.socleSmCm != null)
        props['Hauteur socle sur mesure'] = String(S.socleSmCm).replace('.', ',') + ' cm'
          + (S._socleSmBrk ? ' (tarifee sur la tranche ' + S._socleSmBrk + ')' : '');
      if (S.revetement) props['Revêtement'] = S.revetement;
      props['Matelas'] = S.matType;
      /* 🛑 L'ALGICIDE OFFERT DOIT ATTEINDRE L'ATELIER.
         Le moteur v1 posait cette propriete depuis le debut ; v2 ne l'a
         jamais fait. Depuis que le configurateur vit sur la fiche produit,
         TOUTE vente de lit passe par v2 — le cadeau promis n'etait donc
         ecrit sur aucune commande, et celui qui prepare le colis ne pouvait
         pas le savoir. Mesure du 21/09 : zero occurrence de
         « Conditionneur » dans ce fichier.
         Un flacon par POCHE d'eau : v1 le deduisait du libelle de
         configuration (`/deux matelas/i`), on utilise ici `twoSides()`,
         qui dit la meme chose depuis l'etat plutot que depuis un texte. */
      props['Conditionneur offert'] = (twoSides() ? 2 : 1)
        + ' x Akva Long Life 380 ml';
      if (S.teteInc) props['Tête de lit incluse'] = S.teteInc;
      /* ⚠️ REPLI, PAS DOUBLON. Ces deux precisions vivent desormais sur la
         ligne de la tete. Mais si aucune ligne de tete n'a pu etre creee —
         variante introuvable, tete incluse —, les perdre serait pire que les
         repeter : on les reecrit alors sur le lit. */
      var _ligneTete = appoints().some(function (a) { return a.tete; });
      if (!_ligneTete) {
        if (S.teteTier) props['Matière tête de lit'] = S.teteTier;
        if (S.teteCol) props['Couleur tête de lit'] = S.teteCol;
      }
      deductions().forEach(function (d) { props[d.label] = 'oui — remise appliquée au paiement'; });
      var items = [{ id: v.id, quantity: 1, properties: props }];
      /* Chaque appoint peut porter ses propres precisions (cf. `props` dans
         `appoints()`). Sans cette fusion, elles restaient dans le calcul et
         n'atteignaient jamais la commande. */
      appoints().forEach(function (a) {
        if (!a.id) return;
        var pr = { 'Pour': 'Akva ' + (cfg.model || 'lit à eau') };
        Object.keys(a.props || {}).forEach(function (k) { pr[k] = a.props[k]; });
        items.push({ id: a.id, quantity: 1, properties: pr });
      });
      /* 🛑 QUANTITE 1, ET LE PRIX DANS LA VARIANTE. L'ancien porteur valait
         2,00 EUR et la quantite portait les kilometres : `/cart/change.js`
         etant public, un {quantity:1} faisait tomber 296 EUR a 2. Ici baisser
         la quantite ne fait rien, et le titre de la variante inscrit la
         distance sur la facture. */
      if (INSTALL && INSTALL.id) items.push({
        id: INSTALL.id, quantity: 1,
        properties: {
          'Adresse d\u2019installation': INSTALL.adresse || '',
          'Distance': INSTALL.kmReel + ' km depuis notre atelier de Gigean',
          '_km_facture': String(INSTALL.km)
        }
      });
      var orig = addBtn.textContent; addBtn.disabled = true; addBtn.textContent = 'Ajout…';
      var code = dedCode();
      var chain = code ? fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () { }) : Promise.resolve();
      chain.then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items, sections: CF_SECTIONS, sections_url: window.location.pathname }) });
      }).then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); })
        .then(function (rep) {
          addBtn.classList.add('is-done'); addBtn.innerHTML = 'Ajouté au panier ' + SVG_CHECK;
          /* ⚠️ L'ancienne mise a jour ecrivait `item_count` dans
             `.cart-count-bubble span` — un element que `cart-icon-bubble.liquid`
             ne rend PAS quand le panier est vide. Le premier ajout, celui qui
             compte, restait donc muet. On remplace la section entiere. */
          cfAnnoncer(rep);
          setTimeout(function () { addBtn.classList.remove('is-done'); addBtn.disabled = false; addBtn.textContent = orig; }, 2600);
        }).catch(function (err) {
          addBtn.disabled = false; addBtn.textContent = orig;
          if (errEl) { errEl.hidden = false; errEl.textContent = (err && err.description) ? err.description : 'Ajout impossible — réessayez.'; }
        });
    });

    build(); refresh();
  }

  /* ═══════════ MODE CADRE (Nori / Emma) ═══════════
     Variantes du produit : Finition × Largeur(bande) × Version (Cadre seul|Lit complet · avec|sans tête).
     Lit complet = cadre à −10 % (jeu de variantes dédié) + une BASE au prix exact (Soft réduite /
     Inside réduite / matelas Hardside), le socle s'AJOUTE (plein tarif) + plaque de support obligatoire. */
  function initCadre(root, cfg, variants, V) {
    var C = V.cadre;
    var mount = root.querySelector('[data-cf-mount]');
    var priceEl = root.querySelector('[data-cf-price]');
    var bar = root.querySelector('[data-cf-bar]');
    var errEl = root.querySelector('[data-cf-err]');
    if (!mount) return;
    /* 🛑 LE NOM DU MODÈLE N'EST PAS DANS `config_v2` (aucune clé `model`, mesuré le 07/09
       sur Nori et Emma) : le récapitulatif disait « Cadre » et le panier « Pour : Cadre  ».
       La page le pose sur `data-modele` (custom.model) ; on le lit là. */
    var MODELE = cfg.model || root.getAttribute('data-modele') || '';
    /* le plancher = le « Cadre seul » le moins cher : c'est ce que « à partir de » promet */
    var PLANCHER = 0;
    variants.forEach(function (v) { if (String(v.o3 || '').indexOf('Cadre seul') === 0 && (!PLANCHER || v.cents < PLANCHER)) PLANCHER = v.cents; });

    var VMAP = {}; /* finition -> band -> version -> {id, cents} */
    var FINITIONS = [];
    variants.forEach(function (v) { /* ici formule=option1(Finition), stab=option2(Largeur)… le dump ne porte que 2 options */ });
    /* le dump section ne fournit que option1/option2 : re-lire via title "Fin / Band / Version" impossible.
       → on reconstruit depuis cfg.v2.cadre.self (posé par le générateur) OU fallback : option1 contient la finition,
       option2 la largeur — la Version est dans le titre. Le dump v2 étendu ci-dessous couvre les 3 options. */
    variants.forEach(function (v) {
      var fin = v.formule, rest = v.stab, ver = v.o3;
      if (!ver && v.title) { var parts = v.title.split(' / '); ver = parts[2]; }
      if (FINITIONS.indexOf(fin) < 0) FINITIONS.push(fin);
      ((VMAP[fin] = VMAP[fin] || {})[rest] = VMAP[fin][rest] || {})[ver] = { id: v.id, cents: v.cents };
    });

    var stabByKey = {}; (C.stabs || []).forEach(function (s) { stabByKey[s.key] = s; });

    var S = {
      version: null, base: null, fin: FINITIONS[0], tete: null,
      width: null, length: null, system: null,
      stabL: null, stabR: null, sameStab: true, lsL: false, lsR: false,
      socle: null, socleH: '25/30 cm', plaque: 'sans textile', pieds: false, open: 0
    };

    function bandFor(w) { var out = null; C.bands.forEach(function (b) { if (b.widths.indexOf(String(w)) >= 0) out = b; }); return out; }
    function baseDef() { return S.base ? C.bases[S.base] : null; }
    function twoSides() { return S.system === 'dual' || S.system === 'kombi'; }
    function colOf(k) { return (stabByKey[k] || {}).col; }
    function famOf(k) { return (stabByKey[k] || {}).fam; }
    function resolvedStab() {
      if (S.version !== 'complet') return { col: null };
      if (!S.stabL) return null;
      if (!twoSides() || S.sameStab || !S.stabR || S.stabR === S.stabL) return { col: colOf(S.stabL), resKey: S.stabL, mixed: false };
      if (famOf(S.stabL) !== famOf(S.stabR)) return { err: 'Choisissez la même famille des deux côtés (fibres avec fibres, Ergo avec Ergo).' };
      if (famOf(S.stabL) === 'ergo') {
        if (colOf(S.stabL) !== colOf(S.stabR)) return { err: 'Ergo et F-Ergo ne se combinent pas entre eux.' };
        return { col: colOf(S.stabL), resKey: S.stabL, mixed: true };
      }
      var avg = Math.round((stabByKey[S.stabL].num + stabByKey[S.stabR].num) / 2 + 0.0001);
      var res = avg <= 2 ? (avg <= 0 ? 'F0' : 'F2') : 'F' + Math.min(avg, 8);
      return { col: colOf(res), resKey: res, mixed: true };
    }
    function cadreVariant() {
      var b = bandFor(S.width); if (!b || !S.tete || S.version === null) return null;
      var ver = (S.version === 'complet' ? 'Lit complet' : 'Cadre seul') + ' · ' + S.tete;
      return ((VMAP[S.fin] || {})[b.label] || {})[ver] || null;
    }
    function baseRowKey() {
      var bd = baseDef(), b = bandFor(S.width); if (!bd || !b) return null;
      if (S.system === 'uno') return bd.rows[b.key + 'uno'];
      return bd.rows[b.key + 'dk'];
    }
    function baseVariant() {
      if (S.version !== 'complet') return null;
      var bd = baseDef(), rs = resolvedStab();
      if (!bd || !rs || rs.err || !rs.col) return null;
      var o1 = baseRowKey(); if (!o1) return null;
      return bd.variants[o1 + ' · ' + rs.col] || null;
    }
    function pick(map, frags) {
      var out = null;
      Object.keys(map || {}).forEach(function (k) {
        if (out) return;
        if (frags.every(function (f) { return k.indexOf(f) >= 0; })) out = { key: k, id: map[k].id, cents: map[k].cents };
      });
      return out;
    }
    function appoints() {
      var out = [], b = bandFor(S.width);
      if (S.version === 'complet') {
        var bv = baseVariant();
        if (bv) out.push({ label: 'Base ' + baseDef().label, cents: bv.cents, id: bv.id });
        var lsSel = twoSides() ? (S.lsL || S.lsR) : S.lsL;
        var lsOK = [S.stabL, S.sameStab ? S.stabL : S.stabR].some(function (k) { return k && stabByKey[k] && stabByKey[k].ls; });
        if (lsSel && lsOK && b) {
          var d = twoSides() ? C.ls.dual : (C.ls[b.key] || C.ls.b2);
          out.push({ label: 'Support lombaire', cents: d.price * 100, id: d.variant });
        }
      }
      if (S.socle && b) {
        var svv = pick(C.socleFull, [S.socle, b.label, S.socle.indexOf('Benti') >= 0 ? '25' : S.socleH]);
        if (svv) {
          out.push({ label: S.socle, cents: svv.cents, id: svv.id });
          var pq = pick(C.plaque, [S.plaque, b.label]);
          if (pq) out.push({ label: 'Plaques de support (' + S.plaque + ')', cents: pq.cents, id: pq.id });
        }
      }
      if (S.pieds && C.pieds) { var pv = pick(C.pieds.variants, ['massif']); if (pv) out.push({ label: 'Pieds bois (teinté / chêne)', cents: pv.cents, id: pv.id }); }
      return out;
    }
    function complete() {
      if (!S.version || !S.tete || !S.width || !S.length || !cadreVariant()) return false;
      if (S.version === 'complet') { var rs = resolvedStab(); if (!S.base || !S.system || !rs || rs.err || !baseVariant()) return false; }
      return true;
    }

    function pills(list, act, sel) {
      var h = '<div class="cf2__pills">';
      list.forEach(function (it) {
        var v = it.v !== undefined ? it.v : it, label = it.label || it;
        h += '<button type="button" class="cf2__pill' + (sel === v ? ' is-on' : '') + '"' + (it.dis ? ' disabled' : '') +
          ' data-act="' + act + '" data-val="' + esc(v) + '" aria-pressed="' + (sel === v) + '">' + esc(label) +
          (it.dis && it.why ? '<span class="cf2__why">' + SVG_LOCK + ' ' + esc(it.why) + '</span>' : '') + '</button>';
      });
      return h + '</div>';
    }
    function shell(i, title, summary, done, body, open) {
      return '<section class="cf2__step' + (open ? ' is-open' : '') + (done ? ' is-done' : '') + '" data-step="' + i + '">' +
        '<button type="button" class="cf2__head" data-act="open" data-val="' + i + '"><span class="cf2__num">0' + (i + 1) + '</span>' +
        '<span class="cf2__t">' + esc(title) + '</span><span class="cf2__sum">' + (done && !open ? esc(summary || '') : '') + '</span>' +
        '<span class="cf2__chip">' + (done ? SVG_CHECK : '') + '</span></button>' +
        '<div class="cf2__body"' + (open ? '' : ' hidden') + '>' + body +
        (i < 5 ? '<div class="cf2__nextrow"><button type="button" class="cf2__next" data-act="next">Continuer</button></div>' : '') +
        '</div></section>';
    }

    function rVersion() {
      var h = '<div class="cf2__syscards">' +
        '<button type="button" class="cf2__sys' + (S.version === 'seul' ? ' is-on' : '') + '" data-act="version" data-val="seul">' +
        '<b>Cadre seul</b><span>Le cadre, ses pieds et sa tête selon version — votre matelas vous appartient déjà.</span></button>' +
        '<button type="button" class="cf2__sys' + (S.version === 'complet' ? ' is-on' : '') + '" data-act="version" data-val="complet">' +
        '<b>Lit complet</b><span>Cadre + lit à eau intégré.</span><i>−10 % sur le cadre</i></button></div>';
      if (S.version === 'complet') {
        h += '<div class="cf2__subk">Votre base de couchage</div>' +
          pills(Object.keys(C.bases).map(function (k) { return { v: k, label: C.bases[k].label }; }), 'base', S.base);
        var bd = baseDef();
        if (bd) {
          h += '<div class="cf2__subk">Système</div>' +
            pills(bd.systems.map(function (sy) {
              return { v: sy, label: sy === 'uno' ? 'Un matelas' : sy === 'dual' ? 'Deux matelas séparés' : 'Deux matelas combinés' };
            }), 'csystem', S.system);
          if (bd.notice) h += '<p class="cf2__hint">' + esc(bd.notice) + '</p>';
        }
        h += '<p class="cf2__hint">' + esc(C.remise) + '</p>';
      }
      return h;
    }
    function rFin() {
      var h = '';
      if (FINITIONS.length > 1) h += '<div class="cf2__subk">Finition du cadre</div>' + pills(FINITIONS.map(function (f) { return { v: f, label: f }; }), 'cfin', S.fin);
      else h += '<div class="cf2__subk">Finition</div><p class="cf2__hint">' + esc(FINITIONS[0]) + '</p>';
      h += '<div class="cf2__subk">Tête de lit</div>' + pills([{ v: 'avec tête', label: 'Avec tête de lit' }, { v: 'sans tête', label: 'Sans tête de lit' }], 'ctete', S.tete);
      if (C.pieds) h += '<button type="button" class="cf2__opt' + (S.pieds ? ' is-on' : '') + '" data-act="cpieds"><span class="cf2__box">' + (S.pieds ? SVG_CHECK : '') + '</span><span>Pieds hêtre teinté ou chêne massif</span><em>+ ' + euro(C.pieds.price * 100) + '</em></button>';
      return h;
    }
    function rDims() {
      var h = '<div class="cf2__subk">Largeur (cm)</div>';
      var ws = [];
      C.bands.forEach(function (b) {
        b.widths.forEach(function (w) {
          var dis = false, why = '';
          if (S.version === 'complet' && S.base === 'hardside') {
            var hsW = ['90', '100', '140', '150', '160', '180', '200'];
            if (hsW.indexOf(w) < 0) { dis = true; why = 'Pas de matelas Hardside en ' + w + ' cm'; }
          }
          if (S.version === 'complet' && twoSides() && parseInt(w, 10) < (S.system === 'kombi' ? 150 : 140)) {
            dis = true; why = S.system === 'kombi' ? 'Les matelas combinés démarrent à 150 cm' : 'Deux matelas à partir de 140 cm';
          }
          ws.push({ v: w, label: w, dis: dis, why: why });
        });
      });
      h += pills(ws, 'cwidth', S.width);
      h += '<div class="cf2__subk">Longueur (cm)</div>';
      var b = bandFor(S.width);
      h += !b ? '<p class="cf2__hint">Sélectionnez une largeur.</p>' : pills(b.lengths.map(function (l) { return { v: l, label: l }; }), 'clength', S.length);
      return h;
    }
    function scale(side, sel) {
      var fam = (S['_fam' + side]) || (sel ? famOf(sel) : 'fibres');
      var h = '<div class="cf2__famrow">' + pills([{ v: 'fibres', label: 'Fibres F0–F8' }, { v: 'ergo', label: 'Ergo / F-Ergo' }], 'cfam-' + side, fam) + '</div>';
      h += pills(C.stabs.filter(function (x) { return x.fam === fam; }).map(function (x) { return { v: x.key, label: x.key }; }), 'cstab-' + side, sel);
      if (sel && stabByKey[sel]) h += '<p class="cf2__stabhint">' + esc(stabByKey[sel].hint) + '</p>';
      var lsable = sel && stabByKey[sel].ls, b = bandFor(S.width);
      if (b) {
        var price = twoSides() ? C.ls.dual.price : ((C.ls[b.key] || C.ls.b2).price);
        var on = side === 'L' ? S.lsL : S.lsR;
        h += '<button type="button" class="cf2__opt' + (on ? ' is-on' : '') + '"' + (lsable ? '' : ' disabled') +
          ' data-act="cls-' + side + '"><span class="cf2__box">' + (on ? SVG_CHECK : '') + '</span><span>Support lombaire' + (lsable ? '' : ' — existe en F3 à F7') + '</span><em>+ ' + euro(price * 100) + '</em></button>';
      }
      return h;
    }
    function rStab() {
      if (S.version !== 'complet') return '<p class="cf2__hint">Cadre seul : pas de matelas à configurer.</p>';
      if (!S.system) return '<p class="cf2__hint">Choisissez d’abord la base et le système (étape 01).</p>';
      var h = '';
      if (!twoSides()) h += scale('L', S.stabL);
      else {
        h += '<button type="button" class="cf2__opt' + (S.sameStab ? ' is-on' : '') + '" data-act="csame"><span class="cf2__box">' + (S.sameStab ? SVG_CHECK : '') + '</span><span>Même confort des deux côtés</span></button>';
        if (S.sameStab) h += scale('L', S.stabL);
        else {
          h += '<div class="cf2__sides"><div><div class="cf2__sidek">Côté gauche</div>' + scale('L', S.stabL) + '</div><div><div class="cf2__sidek">Côté droit</div>' + scale('R', S.stabR) + '</div></div>';
          var rs = resolvedStab();
          if (rs && rs.err) h += '<p class="cf2__err2">' + esc(rs.err) + '</p>';
          else if (rs && rs.mixed) h += '<p class="cf2__reskey">Degré résultant ≈ <b>' + esc(rs.resKey) + '</b></p>';
        }
      }
      return h;
    }
    function rSocle() {
      var b = bandFor(S.width);
      var h = '<p class="cf2__hint">Le cadre n’inclut pas de socle : le socle choisi et ses plaques de support s’ajoutent au prix plein.</p>';
      var types = ['Socle decor', 'Socle placage', 'Socle miroir', 'Benti (aluminium)', 'Tiroirs 2 box decor', 'Tiroirs 2 box placage', 'Tiroirs 4 box decor', 'Tiroirs 4 box placage', 'Tiroirs 2-big box decor', 'Tiroirs 2-big box placage', 'Tiroirs 4-big box decor', 'Tiroirs 4-big box placage'];
      var items = [{ v: '', label: 'Sans socle' }];
      types.forEach(function (t) {
        var dis = false, why = '';
        if (t.indexOf('Tiroirs') === 0) {
          if (C.noDrawer) { dis = true; why = C.drawerNote; }
          else if (S.socleH.indexOf('34') < 0) { dis = true; why = C.drawerNote; }
        }
        var sv = b ? pick(C.socleFull, [t, b.label, t.indexOf('Benti') >= 0 ? '25' : S.socleH]) : null;
        if (!dis && b && !sv) { dis = true; why = 'Indisponible dans cette largeur/hauteur'; }
        items.push({ v: t, label: t + (sv ? ' · +' + euro(sv.cents) : ''), dis: dis, why: why });
      });
      h += '<div class="cf2__subk">Hauteur</div>' + pills([{ v: '25/30 cm', label: '25 / 30 cm' }, { v: '34/37,5 cm', label: '34 / 37,5 cm' }], 'csocleh', S.socleH);
      h += '<div class="cf2__subk">Type</div>' + pills(items, 'csocle', S.socle || '');
      if (S.socle) h += '<div class="cf2__subk">Plaques de support (incluses avec le socle)</div>' +
        pills([{ v: 'sans textile', label: 'Sans textile' }, { v: 'avec textile', label: 'Avec textile' }], 'cplaque', S.plaque);
      return h;
    }
    function rRecap() {
      var cv = cadreVariant();
      if (!cv) return '<p class="cf2__hint">Complétez les étapes pour voir votre récapitulatif.</p>';
      var h = '<div class="cf2__lines"><div class="cf2__line"><span>' + esc(MODELE || 'Cadre') + ' · ' + esc(S.fin) + ' · ' + esc((S.version === 'complet' ? 'lit complet (−10 %)' : 'cadre seul') + ' · ' + S.tete) + '</span><b>' + euro(cv.cents) + '</b></div>';
      appoints().forEach(function (a) { h += '<div class="cf2__line"><span>' + esc(a.label) + '</span><b>+ ' + euro(a.cents) + '</b></div>'; });
      h += '</div>';
      h += '<details class="cf2__inc2"><summary>Ce que comprend votre cadre</summary><ul>' + (V.inclus || []).map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul></details>';
      return h;
    }

    var STEPS = [
      { t: 'Votre formule', r: rVersion, done: function () { return !!(S.version && (S.version === 'seul' || (S.base && S.system))); }, sum: function () { return S.version === 'complet' ? 'Lit complet · ' + (baseDef() ? baseDef().label : '') : (S.version ? 'Cadre seul' : ''); } },
      { t: 'Finition & tête', r: rFin, done: function () { return !!S.tete; }, sum: function () { return [FINITIONS.length > 1 ? S.fin : null, S.tete].filter(Boolean).join(' · '); } },
      { t: 'Dimensions', r: rDims, done: function () { return !!(S.width && S.length); }, sum: function () { return S.width && S.length ? S.width + ' × ' + S.length + ' cm' : ''; } },
      { t: 'Confort du matelas', r: rStab, done: function () { if (S.version !== 'complet') return true; var rs = resolvedStab(); return !!(rs && !rs.err && rs.col); }, sum: function () { if (S.version !== 'complet') return '—'; return S.stabL ? (twoSides() && !S.sameStab ? S.stabL + ' / ' + (S.stabR || '—') : S.stabL) : ''; } },
      { t: 'Socle', r: rSocle, done: function () { return true; }, sum: function () { return S.socle || 'Sans socle'; } },
      { t: 'Récapitulatif', r: rRecap, done: function () { return complete(); }, sum: function () { return ''; } }
    ];

    function build() {
      var h = '<div class="cf2">';
      STEPS.forEach(function (st, i) { h += shell(i, st.t, st.sum(), st.done(), st.r(), S.open === i); });
      mount.innerHTML = h + '</div>';
    }
    function totals() {
      var cv = cadreVariant(), t = 0;
      if (cv) { t = cv.cents; appoints().forEach(function (a) { t += a.cents; }); }
      return t;
    }
    function next() {
      if (!STEPS[0].done()) return 'Choisissez votre formule';
      if (!STEPS[1].done()) return 'Choisissez la tête de lit';
      if (!STEPS[2].done()) return 'Choisissez la dimension';
      if (!STEPS[3].done()) return 'Choisissez le confort';
      return 'Complétez votre configuration';
    }
    function refresh() {
      var t = totals(), c = complete();
      /* 🛑 « livré & installé » était faux : la livraison est offerte, l'installation est
         une OPTION à 2 €/km (cf. litaeau-livraison-installation). */
      if (priceEl && t) priceEl.innerHTML = '<b>' + euro(t) + '</b> · TTC, livraison offerte';
      else if (priceEl && PLANCHER) priceEl.innerHTML = 'à partir de <b>' + euro(PLANCHER) + '</b> · cadre seul, sans tête · livraison offerte';
      if (bar) {
        var btn = bar.querySelector('[data-cf-add]'), tot = bar.querySelector('[data-cf-total]'), sub = bar.querySelector('[data-cf-sub]');
        if (tot) tot.textContent = t ? euro(t) : '—';
        if (sub) sub.textContent = c ? (appoints().length ? appoints().length + ' ligne(s) incluse(s)' : 'TTC, livraison offerte') : next();
        if (btn) { btn.disabled = !c; btn.textContent = c ? 'Ajouter au panier' : next(); }
      }
      emit();
    }

    /* 🛑 LE CONTRAT AVEC LA PAGE — le même que le mode lit (cf. litaeau-conf-js.liquid).
       Le mode lit émet `lae:config` à chaque changement et expose `window.__LAE_CFG` ; le
       mode cadre ne faisait ni l'un ni l'autre. Mesuré le 07/09 : sur une page de cadre,
       le rail restait à « 0 % », la barre à « 0 / 7 étapes », `window.__LAE_CFG` valait
       undefined, et aucune sonde ne pouvait lire un prix. Mêmes noms de clés, mêmes
       statuts (fait / attente / option / hors) : le pilote coche sans rien savoir du cadre. */
    function etapesDe() {
      var rs = resolvedStab();
      return {
        formule: STEPS[0].done() ? 'fait' : 'attente',
        fin: S.tete ? 'fait' : 'attente',
        dim: (S.width && S.length) ? 'fait' : 'attente',
        stab: S.version === 'seul' ? 'hors' : ((rs && !rs.err && rs.col) ? 'fait' : 'attente'),
        /* 🛑 « option » etait ecrit EN DUR : l'etape ne pouvait jamais devenir
           « fait », meme le socle choisi. Elle reste facultative — un cadre
           s'achete sans socle — mais elle se coche quand on en prend un. */
        socle: S.socle ? 'fait' : 'option'
      };
    }
    function prochaineEtape() {
      var e = etapesDe(), ORDRE = ['formule', 'fin', 'dim', 'stab'];
      var TXT = { formule: 'Votre formule', fin: 'Finition et tête', dim: 'Les dimensions', stab: 'Le confort du matelas' };
      for (var i = 0; i < ORDRE.length; i++) if (e[ORDRE[i]] === 'attente') return { cle: ORDRE[i], txt: TXT[ORDRE[i]] };
      return { cle: '', txt: '' };
    }
    function emit() {
      var p = prochaineEtape();
      var det = {
        cadre: true, modele: MODELE, version: S.version, base: S.base, system: S.system,
        fin: S.fin, tete: S.tete, width: S.width, length: S.length,
        stabL: S.stabL, stabR: S.stabR, sameStab: S.sameStab, lsL: S.lsL, lsR: S.lsR,
        socleType: S.socle, socleH: S.socleH, plaque: S.plaque, piedsOn: S.pieds,
        complet: complete(), total: totals(),
        etapes: etapesDe(), prochaineCle: p.cle, prochaineTxt: p.txt
      };
      window.__LAE_DERNIER_CONFIG = det;
      document.dispatchEvent(new CustomEvent('lae:config', { detail: det }));
    }
    window.__LAE_CFG = {
      pret: true, cadre: true, modele: MODELE,
      etat: function () { return window.__LAE_DERNIER_CONFIG || null; },
      /* en CENTIMES, comme le mode lit ; null tant que la configuration n'est pas résolue */
      prixActuel: function () { try { return complete() ? totals() : null; } catch (e) { return null; } },
      prixPlancher: function () { return PLANCHER; },
      /* `choisir(act, val)` clique le bouton du panneau — même geste que le client, donc
         même résultat ; une sonde peut dérouler un parcours entier sans toucher au DOM. */
      choisir: function (act, val) {
        var sel = '[data-act="' + act + '"]' + (val === undefined || val === null ? '' : '[data-val="' + String(val).replace(/"/g, '\\"') + '"]');
        var b = mount.querySelector(sel);
        if (b && !b.disabled) b.click();
        return !!b;
      },
      ouvrir: function (n) { S.open = n; build(); refresh(); }
    };
    mount.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]'); if (!b || b.disabled) return;
      var a = b.getAttribute('data-act'), val = b.getAttribute('data-val');
      if (a === 'open') { S.open = (S.open === +val ? -1 : +val); build(); refresh(); return; }
      if (a === 'next') { S.open = Math.min(S.open + 1, 5); build(); refresh(); return; }
      if (a === 'version') { S.version = val; if (val === 'seul') { S.base = S.system = null; S.stabL = S.stabR = null; } }
      else if (a === 'base') { S.base = val; if (S.system && baseDef().systems.indexOf(S.system) < 0) S.system = null; }
      else if (a === 'csystem') { S.system = val; if (!twoSides()) { S.stabR = null; S.lsR = false; S.sameStab = true; } }
      else if (a === 'cfin') { S.fin = val; }
      else if (a === 'ctete') { S.tete = val; }
      else if (a === 'cpieds') { S.pieds = !S.pieds; }
      else if (a === 'cwidth') { S.width = val; S.length = null; }
      else if (a === 'clength') { S.length = val; }
      else if (a === 'cfam-L') { S._famL = val; if (S.stabL && famOf(S.stabL) !== val) S.stabL = null; }
      else if (a === 'cfam-R') { S._famR = val; if (S.stabR && famOf(S.stabR) !== val) S.stabR = null; }
      else if (a === 'cstab-L') { S.stabL = val; if (!stabByKey[val].ls) S.lsL = false; }
      else if (a === 'cstab-R') { S.stabR = val; if (!stabByKey[val].ls) S.lsR = false; }
      else if (a === 'csame') { S.sameStab = !S.sameStab; if (S.sameStab) S.stabR = null; }
      else if (a === 'cls-L') { S.lsL = !S.lsL; }
      else if (a === 'cls-R') { S.lsR = !S.lsR; }
      else if (a === 'csocleh') { S.socleH = val; if (S.socle && S.socle.indexOf('Tiroirs') === 0 && val.indexOf('34') < 0 && !C.noDrawer) S.socle = null; }
      else if (a === 'csocle') { S.socle = val || null; }
      else if (a === 'cplaque') { S.plaque = val; }
      build(); refresh();
    });
    var addBtn = bar ? bar.querySelector('[data-cf-add]') : null;
    if (addBtn) addBtn.addEventListener('click', function () {
      var cv = cadreVariant(); if (!cv || addBtn.disabled) return;
      var props = { 'Version': (S.version === 'complet' ? 'Lit complet (cadre −10 %)' : 'Cadre seul') + ' · ' + S.tete,
                    'Dimension': S.width + ' × ' + S.length + ' cm' };
      if (FINITIONS.length > 1) props['Finition'] = S.fin;
      if (S.version === 'complet') {
        props['Base'] = baseDef().label;
        var rs = resolvedStab();
        if (twoSides() && !S.sameStab) { props['Stabilisation côté gauche'] = S.stabL; props['Stabilisation côté droit'] = S.stabR; props['Degré résultant'] = rs.resKey; }
        else props['Stabilisation'] = S.stabL;
      }
      if (S.socle) { props['Socle'] = S.socle + ' · ' + S.socleH; }
      var items = [{ id: cv.id, quantity: 1, properties: props }];
      appoints().forEach(function (a2) { if (a2.id) items.push({ id: a2.id, quantity: 1, properties: { 'Pour': 'Cadre ' + MODELE } }); });
      var orig = addBtn.textContent; addBtn.disabled = true; addBtn.textContent = 'Ajout…';
      /* ⚠️ Le mode cadre ne tentait MEME PAS de mettre la pastille a
         jour. N'en corriger qu'un des deux aurait laisse Emma et Nori
         muets, c'est-a-dire la moitie des pages. */
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items, sections: CF_SECTIONS, sections_url: window.location.pathname }) })
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); })
        .then(function (rep) {
          addBtn.classList.add('is-done'); addBtn.innerHTML = 'Ajouté au panier ' + SVG_CHECK;
          cfAnnoncer(rep);
          setTimeout(function () { addBtn.classList.remove('is-done'); addBtn.disabled = false; addBtn.textContent = orig; }, 2600);
        }).catch(function (err) {
          addBtn.disabled = false; addBtn.textContent = orig;
          if (errEl) { errEl.hidden = false; errEl.textContent = (err && err.description) ? err.description : 'Ajout impossible — réessayez.'; }
        });
    });
    build(); refresh();
  }

  /* 🛑 L'AJOUT AU PANIER DOIT SE VOIR. Tout existe deja dans le theme —
     `snippets/cart-notification.liquid` est rendu par l'en-tete,
     `assets/cart-notification.js` expose `renderContents()` — mais rien ne le
     declenchait. Et la pastille ne se mettait pas a jour sur un panier VIDE,
     parce que `cart-icon-bubble.liquid` ne rend `.cart-count-bubble` que
     `{% if cart != empty %}` : il n'y avait aucun element a ecrire.
     En demandant les sections, Shopify les REND, et on remplace le balisage —
     la pastille est donc reconstruite, presente ou non. */
  var CF_SECTIONS = 'cart-notification-product,cart-notification-button,cart-icon-bubble';

  function cfPoserSection(id, html) {
    var cible = document.getElementById(id);
    if (!cible || !html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.querySelector('.shopify-section') || doc.body;
    if (!src) return false;
    cible.innerHTML = src.innerHTML;
    return true;
  }

  function cfAnnoncer(rep) {
    var sections = rep && rep.sections;
    if (!sections) return;
    /* ⚠️ La cle du LIT, pas d'un appoint : `/cart/add.js` avec `items` ne pose
       pas de `key` a la racine, et une confirmation qui annoncerait « Socle
       placage » au lieu du lit serait pire que pas de confirmation. */
    var cle = rep.key || (rep.items && rep.items[0] && rep.items[0].key) || '';
    var cn = document.querySelector('cart-notification');
    if (cn && cle && typeof cn.renderContents === 'function') {
      try { cn.renderContents({ key: cle, sections: sections }); return; }
      catch (e) { /* on retombe sur la pastille seule, ci-dessous */ }
    }
    /* 🛑 REPLI REEL, PAS MASQUE : le defaut signale est de ne RIEN savoir.
       Si la bande de confirmation ne s'ouvre pas, la pastille doit au moins
       bouger — sinon on a remplace un silence par un autre. */
    cfPoserSection('cart-icon-bubble', sections['cart-icon-bubble']);
  }

  document.querySelectorAll('[data-cf-v2]').forEach(init);
})();
